//https://js-confuser.com/editor --> Low
/* tempjs.js*/

// ── GROUP HEADERS helper ──
function buildModelOptionsWithGroups(sourceOptions, attrClass) {
  var fragment = document.createDocumentFragment();
  var currentGroup = null;

  sourceOptions.forEach(function(opt) {
    var cls = (opt.className || '').trim();
    if (cls !== (attrClass || '').trim()) return;

    var txt = opt.text.trim();
    var startyear = (opt.getAttribute('startyear') || '').trim();

    if (startyear === 'GROUP') {
      currentGroup = document.createElement('optgroup');
      currentGroup.label = txt;
      fragment.appendChild(currentGroup);
    } else {
      var newOpt = document.createElement('option');
      newOpt.value = txt;
      newOpt.text = txt;
      newOpt.setAttribute('startyear', startyear);
      if (currentGroup) {
        currentGroup.appendChild(newOpt);
      } else {
        fragment.appendChild(newOpt);
      }
    }
  });

  return fragment;
}

window.initModelFilters = function () {

  $('#modelyear').change(function(){ 
    
  $('#make').empty();
  $('select#make').append('<option value="">Make</option>'); 
    
    $('#models').html("");
    $('#models').append("<option value=''>Model</option>");

    
    $('#getMakesFromHere').find("option").each(function(i, item){
      var cls = $(this).attr('attr-class');
      $('#make').append("<option attr-class='"+cls+"' value='"+item.value+"'>"+item.text+"</option>");
    });

    
  });
  
  /*
  $('#make').change(function(){   
    $('#models').html("");
    $('#models').append("<option value=''>Model</option>");
    var attr_class = $( "#make option:selected" ).attr("attr-class");
    $('#model-hidden').find("option").each(function(){
      var cls = $(this).attr('class');
      cls = $.trim(cls);
      attr_class = $.trim(attr_class);
      if (cls == attr_class) {
        var txt = $(this).text();
        txt = $.trim(txt);
        var startyear = $(this).attr('startyear');
        $('#models').append("<option startyear='"+startyear+"' value='"+txt+"'>"+txt+"</option>");
      }
    });
  });
  */



  $('#make').change(function(){
    $('#models').html("");
    $('#models').append("<option value=''>Model</option>");
    var attr_class = $("#make option:selected").attr("attr-class");

    var excluded = [];
    if (window.__excludedModels && window.__excludedModels.length) {
      excluded = window.__excludedModels.map(function(m){ return m.trim().toLowerCase(); });
    }

    // Collect matching options
    var sourceOptions = [];
    $('#model-hidden').find("option").each(function(){
      var cls = $.trim($(this).attr('class'));
      if (cls === $.trim(attr_class)) {
        var startyear = ($(this).attr('startyear') || '').trim();
        var txt = $.trim($(this).text());
        // Skip excluded non-group options only
        if (startyear !== 'GROUP' && excluded.length && excluded.indexOf(txt.toLowerCase()) !== -1) return;
        sourceOptions.push(this);
      }
    });

    // Build with optgroup headers
    var modelSelect = document.getElementById('models');
    var fragment = buildModelOptionsWithGroups(sourceOptions, attr_class);
    modelSelect.appendChild(fragment);

    // Existing sessionStorage reset logic (unchanged)
    var stored = sessionStorage.getItem('model_filters');
    if (stored) {
      try {
        var filters = JSON.parse(stored);
        if (filters) {
          var storedModel = filters.Model ? filters.Model.trim().toLowerCase() : '';
          var modelExcluded = storedModel && excluded.length && excluded.indexOf(storedModel) !== -1;
          var modelEmpty = !storedModel;
          if (modelExcluded || modelEmpty) {
            sessionStorage.removeItem('model_filters');
            window.__excludedModelReset = true;
            $('#modelyear').val('');
            $('#make').val('');
            $('#models').html("<option value=''>Model</option>");
            $('div#dynamicBlockText').addClass('changingNow');
            $('div#car-properties-container').removeClass('hidden');
            setTimeout(function(){
              $('#modelyear').val('');
              $('#make').val('');
              $('#models').html("<option value=''>Model</option>");
            }, 50);
            return;
          }
        }
      } catch(e) {}
    }
  });



  $('#models').change(function(){    
  /*
    $('select#modelyear').empty();
    $('select#modelyear').append('<option value="">Year</option>');
    var startyear = $( "#models option:selected" ).attr("startyear");

    var today = new Date();
    var yearfull = today.getFullYear();
    for (i = yearfull; i >= startyear; i--) {
      $('select#modelyear').append('<option value="'+i+'">'+i+'</option>');
    }
    */

    // If a reset just happened due to excluded model, skip saving to session
    if (window.__excludedModelReset) {
      window.__excludedModelReset = false;
      return;
    }
    

    if($('div#dynamicBlockText').length>0)
    {
    $('div#dynamicBlockText').removeClass('changingNow');
    $('div#car-properties-container').addClass('hidden');

  let model_filters = {
      Make: null,
      Model: null,
      Year: null,
    };
    if(model_filters)
    {
    model_filters.Make = $('select#make').val();
    model_filters.Model = $('select#models').val();
    model_filters.Year = $('select#modelyear').val();

    sessionStorage.setItem("model_filters", JSON.stringify(model_filters));
    } 
      
    window.setTexts();
    }



    if (document.body.classList.contains("template-index")) {
    /*on homepage sending to next page automatically */
    var btnFind = document.querySelector('.btn--find');
    if(btnFind)
    {
      btnFind.click();
    }
    }

    if (typeof(window.applyCarTitleData)=="function")window.applyCarTitleData();
    

    if(typeof(runVariantHideRules) == "function")
      runVariantHideRules($(this).val()); 

  });

}
  
window.initModelFilters();


$(document).ready(function(){
  $('.btn--find').click(function(){
    var make  = $('#make').val(),
        model = $('#models').val(),
        modelyear = $('#modelyear').val();
    if(make == "" || model == "" || modelyear == ""){
      $('html, body').animate({
        scrollTop: $(".error").offset().top-300
      }, 500);
      $('.error').html('<p>Please select your car make, model and year</p>');
      setTimeout(function(){ 
        $('.btn--find').removeClass('btn--loading');
      }, 2000);
    }else{
      window.location.href = 'https://' + document.domain + '/collections?model_filter=Make:'+ make + '+Model:'+ model + '+Year:' + modelyear;
    }
  });

  $('select').change(function(){
    $('.error').html('');
  });
}); 
 
  
  
  function myFunction() {
    
  var x = document.getElementById("models").value;
     var x1 = document.getElementById("make").value;
     var x2 = document.getElementById("modelyear").value; 
    
    localStorage.setItem("Model", x);
     localStorage.setItem("make", x1);
     localStorage.setItem("modelyear", x2);

   var res= localStorage.getItem("Model");
    
    console.log(res);
    
}
  
  





document.addEventListener("DOMContentLoaded", function () {
  let model_filters = {
    Make: null,
    Model: null,
    Year: null,
  };

  let carPropertiesContainer = document.getElementById(
    "car-properties-container"
  );
  if (!carPropertiesContainer) return;

  if (document.body.classList.contains("template-index")) {
    carPropertiesContainer.addEventListener("change", function (event) {
      let targetElem = event.target;
      switch (targetElem.name) {
        case "properties[Make]":
          model_filters.Make = targetElem.value;
          break;
        case "properties[Model]":
          model_filters.Model = targetElem.value;
          break;
        case "properties[Year]":
          model_filters.Year = targetElem.value;
          break;
        default:
          return;
      }

      sessionStorage.setItem("model_filters", JSON.stringify(model_filters));
      //     console.log(event);
    });

if(sessionStorage.getItem("model_filters")!=null)
{
    model_filters = JSON.parse(sessionStorage.getItem("model_filters"));
    let yearSelect = document.getElementById("modelyear");
    let makeSelect = document.getElementById("make");
    let modelSelect = document.getElementById("models");
    


    if(model_filters)
    {yearSelect.value = model_filters.Year;
    yearSelect.dispatchEvent(new Event("change"));
    }
    
    if(model_filters)
    {makeSelect.value = model_filters.Make;
    makeSelect.dispatchEvent(new Event("change"));
    }
    
     if(model_filters)
     {modelSelect.value = model_filters.Model;
    // modelSelect.dispatchEvent(new Event("change"));
     }
}
    
  } else if (document.body.classList.contains("template-product")) {
    
    model_filters = JSON.parse(sessionStorage.getItem("model_filters"));
    let yearSelect = document.getElementById("modelyear");
    let makeSelect = document.getElementById("make");
    let modelSelect = document.getElementById("models");
    


    if(model_filters)
    {
      $('div#car-properties-container').addClass('hidden');
    }
    
    if(model_filters)
    {yearSelect.value = model_filters.Year;
    yearSelect.dispatchEvent(new Event("change"));
    }
    
    if(model_filters)
    {makeSelect.value = model_filters.Make;
    makeSelect.dispatchEvent(new Event("change"));
    }
    
     if(model_filters)
     {modelSelect.value = model_filters.Model;
     modelSelect.dispatchEvent(new Event("change"));
     }

    window.model_filters = model_filters;

      
  }
});



 $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
//    $(function() {
//      // (Optional) Active an item if it has the class "is-active"	
//      $("#mobile-tabs .accordion-item.is-active").children(".accordion-panel").slideDown();

//      $("#mobile-tabs .accordion-item .accordion-thumb").click(function() {
//        // Cancel the siblings
      
//  	  $(this).parent().siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
//        // Toggle the item
//        $(this).parent().toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
      
//      });
//    });
   
  
     var res= localStorage.getItem("Model"); 
   
   
   
  });

 var acc = document.getElementsByClassName("up_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("is-active");
    var panel = this.nextElementSibling;
   
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    
       $(this).parent().siblings(".accordion-item").removeClass("is-active").children(".accordion-panel");
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      
        $(this).parent().toggleClass("is-active");
      
    }
  });
}


 


//update image for personalisation logo option ──────────
function updateCarLogoImages() {
  var model = '';
  var stored = sessionStorage.getItem('model_filters');
  if (stored) {
    try {
      var filters = JSON.parse(stored);
      if (filters && filters.Model) model = filters.Model.trim().toLowerCase();
    } catch(e) {}
  }

  document.querySelectorAll('.carlogo-dynamic-image').forEach(function(img) {
    var defaultSrc = img.getAttribute('data-default');
    var matched = null;
    var raw = img.getAttribute('data-carlogo-map');

    if (model && raw) {
      try {
        var list = JSON.parse(raw);
        var hit = list.find(function(e) {
          return e.model && e.model.trim().toLowerCase() === model;
        });
        if (hit) matched = hit.logo;
      } catch(e) {}
    }

    img.src = matched || defaultSrc;

    // ── Hide fallback logic ──
    var carlogoLabel = img.closest('label[data-carlogo-label]');
    if (!carlogoLabel) return;

    var hideFallback = carlogoLabel.getAttribute('data-hide-fallback') === 'true';
    if (!hideFallback) return;

    var radioInput = document.getElementById(carlogoLabel.getAttribute('for'));
    if (!radioInput) return;

    var logoRadios = carlogoLabel.closest('.logoRadios');
    if (!logoRadios) return;

    if (!matched) {
      // No match — hide the car logo label
      carlogoLabel.classList.add('carlogo-hidden');

      // Only auto-select if the car logo option is currently checked
      // (avoid disrupting an already valid selection)
      if (radioInput.checked) {
        var firstVisibleLabel = logoRadios.querySelector('label:not(.carlogo-hidden)');
        if (firstVisibleLabel) {
          var firstInput = document.getElementById(firstVisibleLabel.getAttribute('for'));
          if (firstInput) {
            // Check the input
            firstInput.checked = true;
            // Fire change event for any listeners
            firstInput.dispatchEvent(new Event('change', { bubbles: true }));
            // Click the logoRadios container to trigger letsDoThis()
            logoRadios.click();
          }
        }
      }

    } else {
      // Match found — restore it
      carlogoLabel.classList.remove('carlogo-hidden');
    }
  });
}

//update image for make-based logo options ──────────
function updateCarMakeLogoImages() {
  var make = '';
  var stored = sessionStorage.getItem('model_filters');
  if (stored) {
    try {
      var filters = JSON.parse(stored);
      if (filters && filters.Make) make = filters.Make.trim().toLowerCase();
    } catch(e) {}
  }

  document.querySelectorAll('.carmakelogo-dynamic-image').forEach(function(img) {
    var defaultSrc = img.getAttribute('data-default');
    var matched = null;
    var raw = img.getAttribute('data-carmakelogo-map');

    if (make && raw) {
      try {
        var list = JSON.parse(raw);
        var hit = list.find(function(e) {
          return e.make && e.make.trim().toLowerCase() === make;
        });
        if (hit) matched = hit.logo;
      } catch(e) {}
    }

    img.src = matched || defaultSrc;

    // ── Hide fallback logic ──
    var carmakelogoLabel = img.closest('label[data-carmakelogo-label]');
    if (!carmakelogoLabel) return;

    var hideFallback = carmakelogoLabel.getAttribute('data-hide-fallback') === 'true';
    if (!hideFallback) return;

    var radioInput = document.getElementById(carmakelogoLabel.getAttribute('for'));
    if (!radioInput) return;

    var logoRadios = carmakelogoLabel.closest('.logoRadios');
    if (!logoRadios) return;

    if (!matched) {
      carmakelogoLabel.classList.add('carlogo-hidden');

      if (radioInput.checked) {
        var firstVisibleLabel = logoRadios.querySelector('label:not(.carlogo-hidden)');
        if (firstVisibleLabel) {
          var firstInput = document.getElementById(firstVisibleLabel.getAttribute('for'));
          if (firstInput) {
            firstInput.checked = true;
            firstInput.dispatchEvent(new Event('change', { bubbles: true }));
            logoRadios.click();
          }
        }
      }
    } else {
      carmakelogoLabel.classList.remove('carlogo-hidden');
    }
  });
}


window.setTexts = function()
  { 
  var res= '';
  var res1= '';
  var res2= '';


  if(sessionStorage.getItem("model_filters")!=null)
  {
      model_filters = JSON.parse(sessionStorage.getItem("model_filters")); 

      if(model_filters)
      {
       res2 = model_filters.Year; 
      }
      
      if(model_filters)
      {
        res = model_filters.Make; 
      }
      
      if(model_filters)
      {
        res1 = model_filters.Model; 

 
        $('div#dynamicBlockText').removeClass('changingNow');
      }


     

    if (typeof(updateCarLogoImages)=="function") updateCarLogoImages();
    if (typeof(updateCarMakeLogoImages)=="function") updateCarMakeLogoImages();

  }

  
if(res1==''){
res1='EXACT VEHICLE ';
}
    
  $(".test").text(res2+ " " +res+""+res1 );
  jQuery('#result').html(res2+' '+res+' '+res1);
 
  if(res2 != "")$('div#car-properties-container').addClass('hidden');
  }
  window.setTexts();
document.addEventListener("cart:change", (event) => {
  window.setTexts();
});document.addEventListener("submit", (event) => {
  setTimeout(function(){window.setTexts();;},2000);
});  
document.addEventListener("pageshow", (event) => {
  window.setTexts();
});
 


  $(document).ready(function() {
    var Delay = 500, ToolTipTimer
    $('.tooltip').hover(function(e){
      var title = $(this).attr('title');
      $(this).data('ToolTipText', title).removeAttr('title');
      $('<div class="wy-tooltip wy-hide"></div>').html(title).appendTo(document.body);
      ToolTipTimer  = setTimeout(function(e) {
        $('.wy-tooltip').removeClass('wy-hide').fadeIn('fast');
      },Delay);
    }, function() {
      clearTimeout(ToolTipTimer);
      $(this).attr('title', $(this).data('ToolTipText'));
      $('.wy-tooltip').remove();
    }).mousemove(function(e) {
      var pLeft;
      var pTop;
      var offset = 10;
      var CursorX = e.pageX;
      var CursorY = e.pageY;
      var WindowWidth = $(window).width();
      var WindowHeight = $(window).height();
      var toolTip = $('.wy-tooltip');
      var TTWidth = toolTip.width();
      var TTHeight = toolTip.height();			
      if (CursorX-offset >= (WindowWidth/4)*3) {
        pLeft = CursorX - TTWidth - offset;
      } else {
        pLeft = CursorX + offset;
      }
      if (CursorY-offset >= (WindowHeight/4)*3) {
        pTop = CursorY - TTHeight - offset;
      } else {
        pTop = CursorY + offset;
      }
      $('.wy-tooltip').css({ top: pTop, left: pLeft })			
    });







var customImage=document.querySelector('#withLogoImage');
  if(customImage)
  {
    if(window.customLogoPurchase){
        var url = getCurrentlogo();
        if(url)
        {
        customImage.src=url; 
        }
    }
  }

    
  });

function resetLogoBlock()
  {
  if(window.customLogoPurchase){
        if(document.querySelector("#logoBlockInput"))
        { 
            document.querySelector("#logoBlockInput").value="";  
        }     
    }
  }
function setLogoBlock()
  { 
   if(window.customLogoPurchase){
    if(document.querySelector("#logoBlockInput"))
    {
        var url = getCurrentlogo();
        if(url)
        {
        document.querySelector("#logoBlockInput").value=url; 
        }
    }
    }
  }


function resetLogoBlock2()
  {
  if(window.customLogoPurchase){
    if(document.querySelector("#logoBlockInput2"))
    { 
        document.querySelector("#logoBlockInput2").value="";  
    } 
    }
  }
function setLogoBlock2()
  {
  if(window.customLogoPurchase){
    if(document.querySelector("#logoBlockInput2"))
    {
        var url = getCurrentlogo();
        if(url)
        {
        document.querySelector("#logoBlockInput2").value=url; 
        }
    }
    }
  }









function collSet()
{

  var customImage=document.querySelector('#withLogoImage2');
  if(customImage)
  {
    if(window.customLogoPurchase){
        var url = getCurrentlogo();
        if(url)
        {
        customImage.src=url; 
        }
    }
  }

  
$('#modelyear2').change(function(){   
$('#make2').empty();
$('select#make2').append('<option value="">Make</option>'); 
  
  $('#models2').html("");
  $('#models2').append("<option value=''>Model</option>");

  
   $('#getMakesFromHere2').find("option").each(function(i, item){
    var cls = $(this).attr('attr-class');
    $('#make2').append("<option attr-class='"+cls+"' value='"+item.value+"'>"+item.text+"</option>");
  });

  
});
  
$('#make2').change(function(){
  /*
  $('#modelyear').empty();
  $('select#modelyear').append('<option value="">Year</option>');
  */
  
  $('#models2').html("");
  $('#models2').append("<option value=''>Model</option>");
  var attr_class = $( "#make2 option:selected" ).attr("attr-class");
  $('#model-hidden2').find("option").each(function(){
    var cls = $(this).attr('class');
    cls = $.trim(cls);
    attr_class = $.trim(attr_class);
    if (cls == attr_class) {
      var txt = $(this).text();
      txt = $.trim(txt);
      var startyear = $(this).attr('startyear');
      $('#models2').append("<option startyear='"+startyear+"' value='"+txt+"'>"+txt+"</option>");
    }
  });
});

$('#models2').change(function(){    
/*
  $('select#modelyear').empty();
  $('select#modelyear').append('<option value="">Year</option>');
  var startyear = $( "#models option:selected" ).attr("startyear");

  var today = new Date();
  var yearfull = today.getFullYear();
  for (i = yearfull; i >= startyear; i--) {
    $('select#modelyear').append('<option value="'+i+'">'+i+'</option>');
  }
  */
});

    model_filters = JSON.parse(sessionStorage.getItem("model_filters"));
    let yearSelect2 = document.getElementById("modelyear2");
    let makeSelect2 = document.getElementById("make2");
    let modelSelect2 = document.getElementById("models2");
    


      if(model_filters)
    {
      $('div#car-properties-container2').addClass('hidden');
    }
  
    if(model_filters)
    {yearSelect2.value = model_filters.Year;
    yearSelect2.dispatchEvent(new Event("change"));
    }
    
    if(model_filters)
    {makeSelect2.value = model_filters.Make;
    makeSelect2.dispatchEvent(new Event("change"));
    }
    
     if(model_filters)
     {modelSelect2.value = model_filters.Model;
     modelSelect2.dispatchEvent(new Event("change"));
     }

}

 
function editvehicle()
  {
    $('div#dynamicBlockText').addClass('changingNow');
    $('div#car-properties-container').removeClass('hidden');
    
    $('html, body').animate({scrollTop: $("div#car-properties-container").offset().top-150}, 1000);
    
  }

 



/*
referesh cart 
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
*/


function updatePrice()
{
var price = document.querySelector('select#warrantyId').selectedOptions[0].getAttribute("data-price");
document.getElementById("warrantyPrice").innerHTML = price;

var image = document.querySelector('select#warrantyId').selectedOptions[0].getAttribute("data-image");
document.getElementById("warrantyImage").src = image;
}
function addGuarantee()
{
var idVal = parseInt(document.querySelector("#warrantyId").value);
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: idVal
},
  dataType: 'json', 
 success: function (data) { 
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  })); 
 } 
});

}

  window.applyCarTitleData = function(){
    const car = window.model_filters || {};

    const year = car.Year?.trim();
    const make = car.Make?.trim();
    const model = car.Model?.trim();

    const map = { year, make, model };

    let hasAnyValue = false;

    // Fill all spans across the site
    Object.entries(map).forEach(([key, value]) => {
      const elements = document.querySelectorAll(`[data-car="${key}"]`);

      elements.forEach(el => {
        if (value) {
          el.textContent = value;
          el.style.display = '';
          hasAnyValue = true;
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });
    });

    // Handle product title fallback
    const titleEl = document.querySelector('.product-title[data-default]');

    if (titleEl) {
      if (!hasAnyValue) {
        // No car data → revert to original title
        titleEl.innerHTML = titleEl.dataset.default;
      }
    }
  }


document.addEventListener('DOMContentLoaded', () => {

  window.applyCarTitleData();

  if(!document.querySelector('#models')){
    // here no details, so hide the dynamic text block on collection pages
    document.querySelector("div#dynamicBlockText")?.classList.add("changingNow");
  }
 
});
 

     


// ── 1. STEP PROGRESS FLOW ────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  if (window.__hideProgressBar) return;
  
  const modelSelect = document.querySelector('#car-properties-container select#models');

  const steps = [...document.querySelectorAll('.product-info__buy-buttons form .stepblock')];
  steps.forEach(step => { step.style.display = 'none'; });

  function getTotalSteps() {
    return 1 + steps.filter(s => !s.classList.contains('notactive')).length;
  }

  let totalSteps = getTotalSteps();
  let currentStep = 1;

  // ── progress bar UI ──
  const progressWrap = document.createElement('div');
  progressWrap.className = 'step-progress-wrap';

  const progressBarContainer = document.createElement('div');
  progressBarContainer.className = 'progress-bar-container';
  const progressBar = document.createElement('div');
  progressBar.className = 'step-progress-bar';
  progressBarContainer.appendChild(progressBar);

  const rightContainer = document.createElement('div');
  rightContainer.className = 'progress-right';

  const continueBtn = document.createElement('button');
  continueBtn.type = 'button';
  continueBtn.className = 'continue-step-btn';
  continueBtn.textContent = 'Continue';

  /*
  if(document.querySelector("div#dynamicBlockText"))
    continueBtn.disabled = true;
  else
    continueBtn.disabled = false;
  */

  /*
  continueBtn.addEventListener('click', () => {
    totalSteps = getTotalSteps();
    if (currentStep >= totalSteps) {
      if (typeof window.showSummaryWhenReady === 'function') {
        window.showSummaryWhenReady();
      }
    } else {
      showNextStep();
    }
  });
  */
  /*
  continueBtn.addEventListener('click', () => { 

    // ── Validate mandatory innerstep (Additional Info block) ──
    var mandatoryInnerstep = document.querySelector('.additional_info_tab1 details.mandatory_innerstep');
    if (mandatoryInnerstep) {
      var visibleSet = null;
      mandatoryInnerstep.querySelectorAll('.option-set').forEach(function(set) {
        if (set.style.display !== 'none' && set.style.display !== '') visibleSet = set;
      });
      if (visibleSet) {
        // For set 1 (nested 3 steps), check all three inner steps
        var step1el = visibleSet.querySelector('.step1');
        var step2el = visibleSet.querySelector('.step2');
        var step3el = visibleSet.querySelector('.step3');
        var isValid = false;
        if (step1el) {
          // nested 3-step flow
          var s1checked = !!step1el.querySelector('input[type="radio"]:checked');
          var s2checked = step2el ? !!step2el.querySelector('input[type="radio"]:checked') : true;
          var s3checked = step3el ? !!step3el.querySelector('input[type="radio"]:checked') : true;
          isValid = s1checked && s2checked && s3checked;
        } else {
          isValid = !!visibleSet.querySelector('input[type="radio"]:checked');
        }
        if (!isValid) {
          mandatoryInnerstep.setAttribute('open', '');
          mandatoryInnerstep.scrollIntoView({ behavior: 'smooth', block: 'center' });
          CarFinderToast.show(); // or a custom error message
          return;
        }
      }
    }

    var make = $('#make').val(),
    model = $('#models').val(),
    modelyear = $('#modelyear').val();
    if (make == "" || make == null || model == "" || model == null || modelyear == "" || modelyear == null) {
      $('html, body').animate({ scrollTop: $(".error").offset().top - 300 }, 500);
      CarFinderToast.show();
      return;
    }

    totalSteps = getTotalSteps();
    if (currentStep >= totalSteps) {
      if (typeof window.showSummaryWhenReady === 'function') {
        window.showSummaryWhenReady();
      }
    } else {
      showNextStep();
    }
  });
  */
  continueBtn.addEventListener('click', () => {
      var make = $('#make').val(),
      model = $('#models').val(),
      modelyear = $('#modelyear').val();
      if (make == "" || make == null || model == "" || model == null || modelyear == "" || modelyear == null) {
        $('html, body').animate({ scrollTop: $(".error").offset().top - 300 }, 500);
        CarFinderToast.show();
        return;
      }
 
      
      // ── Validate mandatory innerstep (Additional Info block) ──
      var additionalDetails = document.querySelector('details.additional_info_tab1');
      if (additionalDetails) {
        var additionalStepblock = additionalDetails.closest('.stepblock');
        var stepblockVisible = additionalStepblock &&
          additionalStepblock.style.display !== 'none' &&
          additionalStepblock.style.display !== '' &&
          !additionalStepblock.classList.contains('notactive');

        if (stepblockVisible) {
          // Find the visible option-set that is also mandatory 
          var visibleMandatorySet = null;
          additionalDetails.querySelectorAll('.option-set.mandatory_innerstep').forEach(function(set) {
            if (set.offsetParent !== null || set.style.display === 'flex' || set.style.display === 'block') {
              visibleMandatorySet = set;
            }
          });  
          
          if (visibleMandatorySet) {
            // Check if any innerstep1-group is visible for this model   
            // Use offsetParent to detect actual visibility regardless of display value
            var visibleGroup = null;
            visibleMandatorySet.querySelectorAll('.innerstep1-group').forEach(function(group) {
              if (group.offsetParent !== null && group.style.display !== 'none') visibleGroup = group;
            });

            // Only validate if a group is actually visible (i.e. this model has innerstep options)
            if (visibleGroup) {
              var isValid = true;

              // Check each inner step that actually exists AND is visible
              ['.step1', '.step2', '.step3'].forEach(function(sel) {
                var stepEl = visibleMandatorySet.querySelector(sel);
                if (stepEl && stepEl.style.display !== 'none' && stepEl.style.display !== '') {
                  // For step1, check inside the visible innerstep1-group only
                  // For step2/step3, check the step element itself
                  var container = (sel === '.step1') ? visibleGroup : stepEl;
                  if (!container.querySelector('input[type="radio"]:checked')) {
                    isValid = false;
                  }
                }
              });

              // Fallback: if no inner steps at all, check any radio in the set
              var hasAnyInnerStep = !!visibleMandatorySet.querySelector('.step1, .step2, .step3');
              if (!hasAnyInnerStep) {
                isValid = !!visibleMandatorySet.querySelector('input[type="radio"]:checked');
              }
 

              if (!isValid) {
                if (!additionalDetails.hasAttribute('open')) additionalDetails.setAttribute('open', '');
                setTimeout(function() {
                  // Scroll to the first visible but unchecked inner step
                  var firstInvalidStep = null;
                  ['.step1', '.step2', '.step3'].forEach(function(sel) {
                    if (firstInvalidStep) return;
                    var stepEl = visibleMandatorySet.querySelector(sel);
                    if (stepEl && stepEl.style.display !== 'none' && stepEl.style.display !== '') {
                      var container = (sel === '.step1') ? visibleGroup : stepEl;
                      if (!container.querySelector('input[type="radio"]:checked')) {
                        firstInvalidStep = stepEl;
                      }
                    }
                  });
                  var scrollTarget = firstInvalidStep || additionalDetails;
                  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });

                  // Flash red box-shadow for 3s
                  var prevShadow = scrollTarget.style.boxShadow;
                  scrollTarget.style.transition = 'box-shadow 0.3s ease';
                  scrollTarget.style.boxShadow = 'rgb(255 3 3 / 2%) 0px 1px 3px 0px, rgb(233 16 0) 0px 0px 0px 1px';
                  setTimeout(function() {
                    scrollTarget.style.boxShadow = prevShadow || '';
                    scrollTarget.style.transition = '';
                  }, 3000);

                }, 100);
                return;
              }

            }
          }
        }
      }

      totalSteps = getTotalSteps();
      if (currentStep >= totalSteps) {
        if (typeof window.showSummaryWhenReady === 'function') {
          window.showSummaryWhenReady();
        }
      } else {
        showNextStep();
      }
    });
    
    const stepCount = document.createElement('div');
    stepCount.className = 'step-count';

    rightContainer.appendChild(continueBtn);
    rightContainer.appendChild(stepCount);
    progressWrap.appendChild(progressBarContainer);
    progressWrap.appendChild(rightContainer);

    const anchor = document.querySelector('.product-info__buy-buttons buy-buttons') || steps[0];
    anchor?.before(progressWrap);

    function scrollToStep(el) {
      if (!el) return;
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 450);
    }

    function getActiveSteps() {
      return steps.filter(s => !s.classList.contains('notactive'));
    }

    /*
    function bindStepInputs(stepEl, stepIndex) {
      if (!stepEl) return;
      stepEl.querySelectorAll('input, select, textarea').forEach(input => {
        if (input.dataset.stepbound === 'true') return;
        const handler = () => {
          if (!input.hasAttribute('data-notstep')) triggerNextStep(stepIndex);
        };
        input.addEventListener('change', handler);
        input.addEventListener('input', handler);
        input.dataset.stepbound = 'true';
      });
    }*/

      function bindStepInputs(stepEl, stepIndex) {
        if (!stepEl) return;
        stepEl.querySelectorAll('input, select, textarea').forEach(input => {
          if (input.dataset.stepbound === 'true') return;

          const isTextLike = (
            input.tagName === 'TEXTAREA' ||
            ['text', 'number', 'email', 'tel', 'url', 'search'].includes((input.type || '').toLowerCase())
          );

          const handler = () => {
            if (!input.hasAttribute('data-notstep')) triggerNextStep(stepIndex);
          };

          if (isTextLike) {
            // For text fields: only auto-advance on 'change' (fires on blur or Enter),
            // never on 'input' (which fires on every keystroke).
            input.addEventListener('change', handler);
          } else {
            // Radios, checkboxes, selects: keep original behaviour (change + input).
            input.addEventListener('change', handler);
            input.addEventListener('input', handler);
          }

          input.dataset.stepbound = 'true';
        });
      }

    function showStep(stepIndex, scroll = true) {
      if (stepIndex === 1) return;
      const active = getActiveSteps();
      const stepToShow = active[stepIndex - 2];
      if (!stepToShow || stepToShow.style.display === 'flex') return;
      stepToShow.style.display = 'flex';
      bindStepInputs(stepToShow, stepIndex);
      // Close previous accordion first, then scroll after layout settles
      if (typeof window._luxusOnStepShown === 'function') window._luxusOnStepShown(stepToShow);
      if (scroll) scrollToStep(stepToShow);
    }

    function triggerNextStep(stepIndex) {
      if (currentStep === stepIndex) showNextStep();
    }

    function validateMandatoryStep(stepIndex) {
      if (stepIndex === 1) return true;
      const active = getActiveSteps();
      const step = active[stepIndex - 2];
      if (!step || !step.classList.contains('mandatory_step')) return true;
      const select = step.querySelector('select');
      if (!select) return true;
      if (select.value.trim() === '') {
        select.style.border = '2px solid red';
        select.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      select.style.border = '';
      return true;
    }

    function updateProgress() {
      totalSteps = getTotalSteps();
      const percent = (currentStep / totalSteps) * 100;
      progressBar.style.width = percent + '%';
      stepCount.textContent = 'Step ' + currentStep + ' of ' + totalSteps;
      continueBtn.textContent = (currentStep >= totalSteps) ? 'Finish' : 'Continue';
      continueBtn.style.display = 'inline-flex';
    }

    function showNextStep() {
      totalSteps = getTotalSteps();
      if (!validateMandatoryStep(currentStep)) return;
      if (currentStep >= totalSteps) return;
      currentStep++;
      showStep(currentStep, true);
      updateProgress();
      continueBtn.disabled = false;
    }

    window._luxusInnerStepsDone = function () {
      totalSteps = getTotalSteps();
      if (currentStep >= totalSteps) {
        continueBtn.disabled = false;
        continueBtn.textContent = 'Finish';
      } else {
        showNextStep();
      }
    };

    window._luxusFullReset = function () {
      if (typeof window.removeSummary === 'function') window.removeSummary();
      progressWrap.style.display = '';
      steps.forEach(s => { s.style.display = 'none'; });
      const active = getActiveSteps();
      if (modelSelect && modelSelect.value.trim() !== '') {
        currentStep = 2;
        if (active[0]) {
          active[0].style.display = 'flex';
          bindStepInputs(active[0], 2);
        }
        continueBtn.disabled = false;
      } else {
        currentStep = 1;

        /*
        if(document.querySelector("div#dynamicBlockText"))
          continueBtn.disabled = true;
        else
          continueBtn.disabled = false;
        */


      }
      continueBtn.style.display = 'inline-flex';
      window.dispatchEvent(new Event('stepsUpdated'));
    };

    function resetStepblocksAfterModelChange() {
      steps.forEach(s => { s.style.display = 'none'; });
      totalSteps = getTotalSteps();
      if (modelSelect && modelSelect.value.trim() !== '') {
        currentStep = 2;
        const active = getActiveSteps();
        if (active[0]) {
          active[0].style.display = 'flex';
          bindStepInputs(active[0], 2);
        }
        continueBtn.disabled = false;

        // ── ADD THIS LINE ──
        if (typeof runVariantHideRules === 'function') runVariantHideRules(modelSelect.value);

        
      } else {
        currentStep = 1;

        /*
        if(document.querySelector("div#dynamicBlockText"))
          continueBtn.disabled = true;
        else
          continueBtn.disabled = false;
        */
      }
      continueBtn.style.display = 'inline-flex';
      updateProgress();
    }

    function resetProgressFlow() {
      totalSteps = getTotalSteps();
      if (currentStep > totalSteps) currentStep = totalSteps;
      updateProgress();
    }

    updateProgress();
    if (modelSelect && modelSelect.value.trim() !== '') resetStepblocksAfterModelChange();

    if (modelSelect) {
      modelSelect.addEventListener('change', () => {
        if (typeof window.removeSummary === 'function') window.removeSummary();
        progressWrap.style.display = '';
        resetStepblocksAfterModelChange();
      });
    }

    window.addEventListener('stepsUpdated', () => {
      resetStepblocksAfterModelChange();
      resetProgressFlow();
    });

    // ADD THIS:
    window.addEventListener('stepsCountChanged', () => {
      resetProgressFlow();
    });

    // Enable continue on any input activity
    document.addEventListener('change', () => { if (continueBtn.disabled) continueBtn.disabled = false; });
    document.addEventListener('input',  () => { if (continueBtn.disabled) continueBtn.disabled = false; });

  });


// ── 2. OPTION SETS & INNER STEPS ─────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  const modelSelect   = document.querySelector('#car-properties-container select#models');
  const optionSets    = document.querySelectorAll('.option-set');
  const additionalTab = document.querySelector('.additional_info_tab');

  function normalize(str) {
    return str ? str.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function findOptionKeyForModel(modelValue) {
    if (!window.metaobjectOptions || !modelValue) return null;
    const nm = normalize(modelValue);
    for (const [key, values] of Object.entries(window.metaobjectOptions)) {
      if (values.map(v => normalize(v)).includes(nm)) return key;
    }
    return null;
  }

  function setupInnerSteps(matchedSet) {
    function reclone(selector) {
      const el = matchedSet.querySelector(selector);
      if (!el) return null;
      const clone = el.cloneNode(true);
      clone.querySelectorAll('.vl-link').forEach(n => n.remove());
      clone.querySelectorAll('[data-vl-injected]').forEach(n => n.removeAttribute('data-vl-injected'));
      if (clone.hasAttribute('data-vl-injected')) clone.removeAttribute('data-vl-injected');
      el.parentNode.replaceChild(clone, el);
      return clone;
    }

    const step1 = reclone('.step1');
    const step2 = reclone('.step2');
    const step3 = reclone('.step3');

    if (!step1 || !step2 || !step3) {
      matchedSet.querySelectorAll('input[type="radio"]').forEach(r => {
        r.addEventListener('change', () => {
          if (typeof window._luxusInnerStepsDone === 'function') window._luxusInnerStepsDone();
        });
      });
      return;
    }

    // ── NEW: writes the checked radio's label text into that step's own
    // .innertitle [class*="selection_here"] span (matches selection_here1/2/3 etc.) ──
    function updateInnerStepSelection(stepEl) {
      const span = stepEl.querySelector('.innertitle [class*="selection_here2"]');
      if (!span) return;

      const checked = stepEl.querySelector('input[type="radio"]:checked');
      if (!checked) { span.textContent = ''; return; }

      let text = '';
      const label = checked.closest('label');
      if (label) {
        const clone = label.cloneNode(true);
        clone.querySelectorAll('img, input, svg, .vl-link').forEach(n => n.remove());
        text = clone.textContent.replace(/\s+/g, ' ').trim();
      }
      if (!text) text = checked.value || '';
      span.textContent = text ? ' · ' + text : '';
    }

    step1.style.display = 'flex';
    step2.style.display = 'none';
    step3.style.display = 'none';
    [step1, step2, step3].forEach(s => {
      s.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
      updateInnerStepSelection(s); // clear any stale text on a fresh set
    });

    function allDone() {
      return (
        !!step1.querySelector('input[type="radio"]:checked') &&
        !!step2.querySelector('input[type="radio"]:checked') &&
        !!step3.querySelector('input[type="radio"]:checked')
      );
    }

    step1.querySelectorAll('input[type="radio"]').forEach(r => {
      r.addEventListener('change', () => {
          updateInnerStepSelection(step1);
          step2.style.display = 'flex';
          setTimeout(() => step2.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
         });
    });
    step2.querySelectorAll('input[type="radio"]').forEach(r => {
      r.addEventListener('change', () => {
        updateInnerStepSelection(step2);
        step3.style.display = 'flex';
        setTimeout(() => step3.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
      });
    });
    step3.querySelectorAll('input[type="radio"]').forEach(r => {
      r.addEventListener('change', () => {
        updateInnerStepSelection(step3);
        if (allDone() && typeof window._luxusInnerStepsDone === 'function') {
          window._luxusInnerStepsDone();
        }
      });
    });
  }

  function showMatchingSet() { 
    if (!modelSelect)return;

    const matchedKey = findOptionKeyForModel(modelSelect.value);
    let matchedSet = null;

    optionSets.forEach(set => {
      if (matchedKey && normalize(set.dataset.option) === normalize(matchedKey)) {
        set.style.display = 'flex';
        matchedSet = set;
      } else {
        set.style.display = 'none';
        set.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
      }
    });

    if (additionalTab) {
      if (!matchedSet) {
        additionalTab.classList.add('notactive');
        additionalTab.style.display = 'none';
      } else {
        additionalTab.classList.remove('notactive');
      }
      window.dispatchEvent(new Event('stepsUpdated'));
    } 

    if (matchedSet) setupInnerSteps(matchedSet);


    // Update label and tooltip when option set changes
    const tooltipImg = document.querySelector('.additional_info_tab1 img.tooltip');
    const summarySpan = document.querySelector('.additional_info_tab1 summary .accordion__toggle .dynamictext');

    if (matchedSet) {
      const newLabel = matchedSet.dataset.label;
      const newTooltip = matchedSet.dataset.tooltiptext;

      if (summarySpan && newLabel) {
        for (const node of summarySpan.childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = ' ' + newLabel + ' ';
            break;
          }
        }
      }
      if (tooltipImg && newTooltip) tooltipImg.setAttribute('title', newTooltip);

    } else {
        const tab = document.querySelector('.additional_info_tab1');
        const defaultLabel = tab?.dataset.defaultLabel || '';
        const defaultTooltip = tab?.dataset.defaultTooltip || '';

        if (summarySpan) {
          summarySpan.textContent = defaultLabel;
        }

        if (tooltipImg) {
          tooltipImg.setAttribute('title', defaultTooltip);
        }
    }

  }

  if (modelSelect) {
    if (modelSelect.value.trim() !== '') showMatchingSet();
    modelSelect.addEventListener('change', showMatchingSet);
  }else{
    if (additionalTab) { 
        additionalTab.classList.add('notactive');
        additionalTab.style.display = 'none';
        window.dispatchEvent(new Event('stepsUpdated'));
    }
  }
});


// ── 3. STEP COMPLETION SUMMARY ───────────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  // ── Extract selected input values from any stepblock ──
  function getStepValue(stepEl) {
    const parts = [];

    // 1. Checked radio buttons → raw input value
    /*
    stepEl.querySelectorAll('input[type="radio"]:checked').forEach(r => {
      if (r.value && r.value.trim()) parts.push(r.value.trim());
    });*/
    stepEl.querySelectorAll('input[type="radio"]:checked').forEach(r => {
      if (r.value && r.value.trim() && !r.hasAttribute('data-upsell-no')) parts.push(r.value.trim());
    });

    // 2. Select dropdowns → raw option value (not text)
    stepEl.querySelectorAll('select').forEach(sel => {
      if (sel.value && sel.value.trim()) parts.push(sel.value.trim());
    });

    // 3. Text / number inputs → raw value
    stepEl.querySelectorAll('input[type="text"], input[type="number"]').forEach(inp => {
      if (inp.value.trim() && !inp.hasAttribute('data-notstep')) parts.push(inp.value.trim());
    });

    // 4. Textareas → raw value
    stepEl.querySelectorAll('textarea').forEach(ta => {
      if (ta.value.trim() && !ta.hasAttribute('data-notstep')) parts.push(ta.value.trim());
    });

    return parts.filter(Boolean).join(', ');
  }

  // ── Derive a label for a stepblock from data-labelv only ──
  function getStepLabel(stepEl, fallbackIndex) {
    if (stepEl.dataset.labelv && stepEl.dataset.labelv.trim()) {
      return stepEl.dataset.labelv.trim();
    }
    return 'Option ' + fallbackIndex;
  }

  // ── Build summary rows ──
  function buildSummaryRows() {
    const rows = [];
    const allStepblocks = document.querySelectorAll('.product-info__buy-buttons form .stepblock');
    let rowIndex = 1;
    allStepblocks.forEach(step => {
      if (step.classList.contains('notactive')) return;
      const label = getStepLabel(step, rowIndex);
      const value = getStepValue(step);
      if (!value || value.trim() === '') { rowIndex++; return; }
      rows.push({ label: label, value: value });
      rowIndex++;
    });
    return rows;
  }

  // ── Render panel DOM ──
  function buildSummaryPanel(rows) {
    const panel = document.createElement('div');
    panel.className = 'step-summary-panel';

    const ul = document.createElement('ul');
    ul.className = 'step-summary-list';

    rows.forEach((r, i) => {
      const li = document.createElement('li');
      li.className = 'step-summary-item';

      const num = document.createElement('span');
      num.className = 'step-summary-num';
      num.textContent = (i + 1) + '.';

      const lbl = document.createElement('span');
      lbl.className = 'step-summary-label';
      lbl.textContent = r.label;

      const val = document.createElement('span');
      val.className = 'step-summary-value';
      val.textContent = r.value;

      li.appendChild(num);
      li.appendChild(lbl);
      li.appendChild(val);
      ul.appendChild(li);
    });

    panel.appendChild(ul);

    const editLink = document.createElement('a');
    editLink.href = '#';
    editLink.className = 'step-summary-edit';
    editLink.textContent = 'Edit Options';
    editLink.addEventListener('click', e => {
      e.preventDefault();
      if (typeof window._luxusFullReset === 'function') window._luxusFullReset();
    });
    panel.appendChild(editLink);

    return panel;
  }

  // ── Public API ──

  window.removeSummary = function () {
    document.querySelector('.step-summary-panel')?.remove();
  };

  window.showSummaryWhenReady = function () {
    const rows = buildSummaryRows();
    const allStepblocks = document.querySelectorAll('.product-info__buy-buttons form .stepblock');
    const progressWrap  = document.querySelector('.step-progress-wrap');
    window.removeSummary();
    allStepblocks.forEach(s => { s.style.display = 'none'; });
    if (progressWrap) progressWrap.style.display = 'none';
    const panel = buildSummaryPanel(rows);
    if (progressWrap) {
      progressWrap.after(panel);
    } else {
      document.querySelector('.product-info__buy-buttons form')?.prepend(panel);
    }
    setTimeout(() => {
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  };

  const modelSelect = document.querySelector('#car-properties-container select#models');
  if (modelSelect) {
    modelSelect.addEventListener('change', () => {
      window.removeSummary();
      const progressWrap = document.querySelector('.step-progress-wrap');
      if (progressWrap) progressWrap.style.display = '';
    });
  }

});


// ── 4. VIEW LARGER POPUP ─────────────────────────────────────
/*
document.addEventListener('DOMContentLoaded', () => {

  const overlay = document.createElement('div');
  overlay.className = 'vl-overlay';
  overlay.innerHTML =
    '<div class="vl-modal">' +
    '<button class="vl-close" aria-label="Close">&#x2715;</button>' +
    '<img class="vl-img" src="" alt="" />' +
    '<p class="vl-caption"></p>' +
    '</div>';
  document.body.appendChild(overlay);

  const vlImg     = overlay.querySelector('.vl-img');
  const vlCaption = overlay.querySelector('.vl-caption');

  function openPopup(src, caption) {
    vlImg.src = src;
    vlCaption.textContent = caption || '';
    overlay.classList.add('vl-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('vl-open');
    document.body.style.overflow = '';
    setTimeout(() => { vlImg.src = ''; }, 300);
  }

  overlay.querySelector('.vl-close').addEventListener('click', closePopup);
  overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });

  function injectViewLarger(root) {
    root = root || document;
    const selector =
      '.product-info__buy-buttons form .stepblock label, ' +
      '.product-info__buy-buttons form .option-set label';

    root.querySelectorAll(selector).forEach(label => {
      if (label.dataset.vlInjected) return;

      const img = [...label.querySelectorAll('img')].find(i =>
        !i.classList.contains('tooltip') &&
        !i.closest('.tooltip') &&
        !(i.getAttribute('src') || '').toLowerCase().includes('tooltip')
      );

      label.dataset.vlInjected = 'true';
      if (!img) return;

      const link = document.createElement('span');
      link.className = 'vl-link';
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      link.setAttribute('aria-label', 'View image larger');
      link.innerHTML =
        '<svg class="vl-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>' +
        '<line x1="10" y1="6" x2="10" y2="14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<line x1="6" y1="10" x2="14" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg> View Larger';

      function handleOpen(e) {
        e.preventDefault();
        e.stopPropagation();

        const src   = img.dataset.imagefull || img.dataset.src || img.getAttribute('src') || '';
        const hiRes = src.replace(/[?&]width=\d+/, '');
      
       // const src   = img.dataset.src || img.getAttribute('src') || '';
       // const hiRes = src.replace(/[?&]width=\d+/, '');
       
        const clone = label.cloneNode(true);
        clone.querySelectorAll('img, input, svg, .vl-link').forEach(n => n.remove());
        //const caption = clone.textContent.replace(/\s+/g, ' ').trim();

        const popupText = img.getAttribute('data-popup_logotext');
         
         console.log(popupText);

        const caption = popupText && popupText.trim()
          ? popupText.trim()
          : (() => {
              const clone = label.cloneNode(true);
              clone.querySelectorAll('img, input, svg, .vl-link').forEach(n => n.remove());
              return clone.textContent.replace(/\s+/g, ' ').trim();
            })(); 


            console.log(caption);

        openPopup(hiRes, caption);
      }

      link.addEventListener('click', handleOpen);
      link.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') handleOpen(e); });

      label.appendChild(link);
    });
  }

  injectViewLarger();

  const form = document.querySelector('.product-info__buy-buttons form');
  if (form) {
    new MutationObserver(() => injectViewLarger(form)).observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

});
*/

// ── 4. VIEW LARGER POPUP ─────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  function isZoomEnabled() {
    return !overlay.classList.contains('vl-no-zoom');
  }
  // ── Build overlay DOM ──
  const overlay = document.createElement('div');
  overlay.className = 'vl-overlay';
  overlay.innerHTML =
  '<div class="vl-modal">' +
    '<button class="vl-close" aria-label="Close">&#x2715;</button>' +
    '<div class="vl-zoom-wrap">' +
      '<img class="vl-img" src="" alt="" />' +
    '</div>' +
    '<div class="vl-zoom-bar">' +
      '<button class="vl-btn-out" aria-label="Zoom out" title="Zoom out">&#x2212;</button>' +
      '<span class="vl-zoom-label">100%</span>' +
      '<button class="vl-btn-in" aria-label="Zoom in" title="Zoom in">&#x2b;</button>' +
      '<button class="vl-btn-rst">Reset</button>' +
    '</div>' +
    '<p class="vl-caption"></p>' +
  '</div>';
  document.body.appendChild(overlay);

  const vlWrap    = overlay.querySelector('.vl-zoom-wrap');
  const vlImg     = overlay.querySelector('.vl-img');
  const vlCaption = overlay.querySelector('.vl-caption');
  const vlLabel   = overlay.querySelector('.vl-zoom-label');
  const btnIn     = overlay.querySelector('.vl-btn-in');
  const btnOut    = overlay.querySelector('.vl-btn-out');
  const btnRst    = overlay.querySelector('.vl-btn-rst');

  // ── Zoom state ──
  const MIN_SCALE = 1, MAX_SCALE = 5, STEP = 0.4;
  let scale = 1, tx = 0, ty = 0;
  let dragging = false, startX, startY, startTx, startTy;
  let lastPinchDist = null;

  function clampTranslate(s, x, y) {
    const iw = vlImg.offsetWidth, ih = vlImg.offsetHeight;
    const maxX = Math.max(0, (iw * s - iw) / 2);
    const maxY = Math.max(0, (ih * s - ih) / 2);
    return { x: Math.max(-maxX, Math.min(maxX, x)), y: Math.max(-maxY, Math.min(maxY, y)) };
  }

  function applyTransform(animated) {
    const clamped = clampTranslate(scale, tx, ty);
    tx = clamped.x; ty = clamped.y;
    vlImg.style.transition = animated ? 'transform .2s ease' : '';
    vlImg.style.transformOrigin = '50% 50%';
    vlImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    vlLabel.textContent = Math.round(scale * 100) + '%';
    vlWrap.classList.toggle('zoomed', scale > 1);
    btnOut.disabled = scale <= MIN_SCALE;
    btnIn.disabled  = scale >= MAX_SCALE;
  }

  function resetZoom(animated) {
    scale = 1; tx = 0; ty = 0;
    applyTransform(animated);
  }

  function zoomTo(newScale, pivotX, pivotY, animated) {
    // pivotX/Y in image-element coordinates (relative to its centre)
    const prev = scale;
    scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
    const ratio = scale / prev;
    tx = pivotX + (tx - pivotX) * ratio;
    ty = pivotY + (ty - pivotY) * ratio;
    applyTransform(animated);
  }

  // ── Open / close ──
  /*
  function openPopup(src, caption) {
    resetZoom(false);
    vlImg.src = src;
    vlCaption.textContent = caption || '';
    overlay.classList.add('vl-open');
    document.body.style.overflow = 'hidden';
  }*/

  function openPopup(src, caption, enableZoom) {
    resetZoom(false);
    vlImg.src = src;
    vlCaption.textContent = caption || '';
    overlay.classList.add('vl-open');
    overlay.classList.toggle('vl-no-zoom', !enableZoom);
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('vl-open');
    document.body.style.overflow = '';
    setTimeout(() => { vlImg.src = ''; resetZoom(false); }, 300);
  }

  overlay.querySelector('.vl-close').addEventListener('click', closePopup);
  overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', e => {
    if (!overlay.classList.contains('vl-open')) return;
    if (e.key === 'Escape') closePopup();
    if (e.key === '+' || e.key === '=') zoomTo(scale + STEP, 0, 0, true);
    if (e.key === '-') zoomTo(scale - STEP, 0, 0, true);
    if (e.key === '0') resetZoom(true);
  });

  // ── Button controls ──
  btnIn.addEventListener('click',  () => zoomTo(scale + STEP, 0, 0, true));
  btnOut.addEventListener('click', () => zoomTo(scale - STEP, 0, 0, true));
  btnRst.addEventListener('click', () => resetZoom(true));

  // ── Click-to-zoom (desktop) ──
  vlWrap.addEventListener('click', e => {
    if (dragging) return;
    if (!isZoomEnabled()) return;

    const r = vlWrap.getBoundingClientRect();
    const px = e.clientX - r.left - r.width  / 2;
    const py = e.clientY - r.top  - r.height / 2;
    if (scale === 1) zoomTo(2, px, py, true);
    else resetZoom(true);
  });

  // ── Scroll-wheel zoom (desktop) ──
  vlWrap.addEventListener('wheel', e => {
    if (!isZoomEnabled()) return;

    e.preventDefault();
    const r  = vlWrap.getBoundingClientRect();
    const px = e.clientX - r.left - r.width  / 2;
    const py = e.clientY - r.top  - r.height / 2;
    const delta = e.deltaY < 0 ? STEP : -STEP;
    zoomTo(scale + delta, px, py, false);
  }, { passive: false });

  // ── Drag-to-pan (mouse) ──
  vlWrap.addEventListener('mousedown', e => {
    if (!isZoomEnabled()) return;

    if (scale <= 1) return;
    dragging = false;
    startX = e.clientX; startY = e.clientY;
    startTx = tx; startTy = ty;
    vlWrap.classList.add('dragging');
    e.preventDefault();

    function onMove(e) {
      const dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) dragging = true;
      tx = startTx + dx; ty = startTy + dy;
      applyTransform(false);
    }
    function onUp() {
      vlWrap.classList.remove('dragging');
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      setTimeout(() => { dragging = false; }, 50);
    }
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });

  // ── Pinch-to-zoom + drag (touch) ──
  function pinchDist(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx*dx + dy*dy);
  }
  function pinchMidpoint(touches) {
    const r = vlWrap.getBoundingClientRect();
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2 - r.left - r.width  / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2 - r.top  - r.height / 2
    };
  }

  vlWrap.addEventListener('touchstart', e => {
    if (!isZoomEnabled()) return;

    if (e.touches.length === 2) {
      lastPinchDist = pinchDist(e.touches);
      e.preventDefault();
    } else if (e.touches.length === 1 && scale > 1) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      startTx = tx; startTy = ty;
    }
  }, { passive: false });

  vlWrap.addEventListener('touchmove', e => {
    if (!isZoomEnabled()) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      const dist = pinchDist(e.touches);
      const mid  = pinchMidpoint(e.touches);
      if (lastPinchDist !== null) {
        const ratio = dist / lastPinchDist;
        zoomTo(scale * ratio, mid.x, mid.y, false);
      }
      lastPinchDist = dist;
    } else if (e.touches.length === 1 && scale > 1) {
      e.preventDefault();
      tx = startTx + (e.touches[0].clientX - startX);
      ty = startTy + (e.touches[0].clientY - startY);
      applyTransform(false);
    }
  }, { passive: false });

  /*
  vlWrap.addEventListener('touchend', e => {
    if (e.touches.length < 2) lastPinchDist = null;
    // double-tap to reset
    const now = Date.now();
    if (now - (vlWrap._lastTap || 0) < 300) {
      scale > 1 ? resetZoom(true) : zoomTo(2, 0, 0, true);
    }
    vlWrap._lastTap = now;
  });
  */
  let wasPinching = false;

  vlWrap.addEventListener('touchend', e => {
    if (!isZoomEnabled()) return;

    if (e.touches.length < 2) {
      if (lastPinchDist !== null) wasPinching = true;
      lastPinchDist = null;
    }
    // double-tap to toggle zoom — skip if pinch just ended
    if (!wasPinching) {
      const now = Date.now();
      if (now - (vlWrap._lastTap || 0) < 300) {
        scale > 1 ? resetZoom(true) : zoomTo(2, 0, 0, true);
      }
      vlWrap._lastTap = now;
    }
    // clear pinch flag once both fingers are up
    if (e.touches.length === 0) wasPinching = false;
  });

  // ── Inject "View Larger" links (unchanged logic) ──
  window._vlInjectViewLarger = function injectViewLarger(root) {
    root = root || document;
    const selector =
      '.product-info__buy-buttons form .stepblock label, ' +
      '.product-info__buy-buttons form .option-set label';

  
    root.querySelectorAll(selector).forEach(label => {
      // skip if already has a vl-link (covers cloned nodes that kept the span)
      if (label.querySelector('.vl-link')) return;

      const img = [...label.querySelectorAll('img')].find(i =>
        !i.classList.contains('tooltip') &&
        !i.closest('.tooltip') &&
        !(i.getAttribute('src') || '').toLowerCase().includes('tooltip')
      );

      label.dataset.vlInjected = 'true';
      if (!img) return;

      const link = document.createElement('span');
      link.className = 'vl-link';
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      link.setAttribute('aria-label', 'View image larger');
      link.innerHTML =
        '<svg class="vl-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>' +
        '<line x1="10" y1="6" x2="10" y2="14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<line x1="6" y1="10" x2="14" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg> View Larger';
      /*
      function handleOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        const src   = img.dataset.imagefull || img.dataset.src || img.getAttribute('src') || '';
        const hiRes = src.replace(/[?&]width=\d+/, '');
        const popupText = img.getAttribute('data-popup_logotext');
        const caption = popupText && popupText.trim()
          ? popupText.trim()
          : (() => {
              const clone = label.cloneNode(true);
              clone.querySelectorAll('img, input, svg, .vl-link').forEach(n => n.remove());
              return clone.textContent.replace(/\s+/g, ' ').trim();
            })();
        openPopup(hiRes, caption);
      }*/

      function handleOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        const src     = img.dataset.imagefull || img.dataset.src || img.getAttribute('src') || '';
        const hiRes   = src.replace(/[?&]width=\d+/, '');
        const popupText = img.getAttribute('data-popup_logotext');
        const caption = popupText && popupText.trim()
          ? popupText.trim()
          : (() => {
              const clone = label.cloneNode(true);
              clone.querySelectorAll('img, input, svg, .vl-link').forEach(n => n.remove());
              return clone.textContent.replace(/\s+/g, ' ').trim();
            })();
        const enableZoom = !!label.closest('.zoomoptions');
        openPopup(hiRes, caption, enableZoom);
      }

      link.addEventListener('click', handleOpen);
      link.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') handleOpen(e); });
      label.appendChild(link);
    });
  }

   window._vlInjectViewLarger();

  /*
  const form = document.querySelector('.product-info__buy-buttons form');
  if (form) {
    new MutationObserver(() => window._vlInjectViewLarger(form)).observe(form, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['style']
    });
  }
  */

    const form = document.querySelector('.product-info__buy-buttons form');
    if (form) {
      let vlObserverTimer = null;
      let vlObserverBusy = false;
      const vlObserver = new MutationObserver(mutations => {
        // ignore mutations caused by our own injection
        if (vlObserverBusy) return;
        // only care about nodes being added, not attribute tweaks
        const hasAddedNodes = mutations.some(m => m.addedNodes.length > 0);
        if (!hasAddedNodes) return;
        clearTimeout(vlObserverTimer);
        vlObserverTimer = setTimeout(() => {
          vlObserverBusy = true;
          window._vlInjectViewLarger(form);
          vlObserverBusy = false;
        }, 50);
      });
      vlObserver.observe(form, { childList: true, subtree: true });
    }

});








// ── 5. ACCORDION AUTO-CLOSE & SELECTION PREVIEW ──────────────
document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('.product-info__buy-buttons form');
  if (!form) return;

  // ── Shared: read raw selected values from a stepblock ──
  function getStepValue(stepEl) {
    const parts = []; 
    stepEl.querySelectorAll('input[type="radio"]:checked').forEach(r => {
      if (r.value && r.value.trim()) parts.push(r.value.trim());
    }); 

    stepEl.querySelectorAll('select').forEach(sel => {
      if (sel.value && sel.value.trim()) parts.push(sel.value.trim());
    });
    stepEl.querySelectorAll('input[type="text"], input[type="number"]').forEach(inp => {
      if (inp.value.trim() && !inp.hasAttribute('data-notstep')) parts.push(inp.value.trim());
    });
    stepEl.querySelectorAll('textarea').forEach(ta => {
      if (ta.value.trim() && !ta.hasAttribute('data-notstep')) parts.push(ta.value.trim());
    });
    return parts.filter(Boolean).join(', ');
  }

  // ── Update span.selection_here in a stepblock's summary ──
  function updateSelectionHere(stepEl) {
    const span = stepEl.querySelector('summary .selection_here');
    if (!span) return;
    const val = getStepValue(stepEl);
    span.textContent = val ? ' · ' + val : '';
  }

  // ── Close/open a stepblock accordion (toggle the details element) ──
  function closeAccordion(stepEl) {
    const details = stepEl.querySelector('details');
    if (details && details.hasAttribute('open')) details.querySelector('summary')?.click();
  }
  function openAccordion(stepEl) {
    const details = stepEl.querySelector('details');
    if (details && !details.hasAttribute('open')) details.querySelector('summary')?.click();
  }

  // ── 1. _luxusOnStepShown: called by section 1's showStep() when a new step appears ──
  // At this point the new stepblock is already display:flex.
  // Close all OTHER visible stepblocks, keep the new one open.
  window._luxusOnStepShown = function (newStepEl) {
    form.querySelectorAll('.stepblock').forEach(s => {
      if (s !== newStepEl && s.style.display !== 'none' && s.style.display !== '') {
        closeAccordion(s);
      }
    });
    // Ensure the newly shown step is open
    openAccordion(newStepEl);
  };

  // ── 2. On reset: open only the first visible stepblock ──
  const _origReset = window._luxusFullReset;
  window._luxusFullReset = function () {
    if (typeof _origReset === 'function') _origReset();
    setTimeout(() => {
      let opened = false;
      form.querySelectorAll('.stepblock').forEach(s => {
        if (s.style.display !== 'none' && s.style.display !== '') {
          if (!opened) { openAccordion(s); opened = true; }
          else closeAccordion(s);
        }
      });
    }, 80);
  };

  // ── 3 & 4. selection_here: pure event delegation ──
  form.addEventListener('change', e => {
    const stepEl = e.target.closest('.stepblock');
    if (stepEl) updateSelectionHere(stepEl);
  });
  form.addEventListener('input', e => {
    const stepEl = e.target.closest('.stepblock');
    if (stepEl) updateSelectionHere(stepEl);
  });

  // Init on load for any pre-filled values
  form.querySelectorAll('.stepblock').forEach(s => updateSelectionHere(s));

});



// ── 6. INNERSTEP1 CONDITIONAL GROUPS ─────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  function normalizeModel(str) {
    return str ? str.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function applyInnerstep1Groups(modelValue) {
    const nm = normalizeModel(modelValue);

    const defaultGroup = document.querySelector('.innerstep1-group.default_innerstep1');
    const condGroups   = document.querySelectorAll('.innerstep1-group.conditional_innerstep1');

    let matchedGroup = null;
    condGroups.forEach(group => {
      let models = [];
      try { models = JSON.parse(group.dataset.innerstep1Models || '[]'); } catch(e) {}
      
      // Debug - remove after confirmed working
      console.log('[innerstep1] checking set:', group.dataset.innerstep1Set, '| models:', models, '| against:', nm);
      
      if (nm && models.some(m => normalizeModel(m) === nm)) {
        matchedGroup = group;
      }
    });

    console.log('[innerstep1] matched:', matchedGroup ? matchedGroup.dataset.innerstep1Set : 'none (default)');

    if (matchedGroup) {
      if (defaultGroup) {
        defaultGroup.style.display = 'none';
        defaultGroup.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
      }
      condGroups.forEach(group => {
        if (group !== matchedGroup) {
          group.style.display = 'none';
          group.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
        }
      });
      matchedGroup.style.display = '';
    } else {
      if (defaultGroup) defaultGroup.style.display = '';
      condGroups.forEach(group => {
        group.style.display = 'none';
        group.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
      });
    }
  }

  // ── Hook into model select ──
  const modelSelect = document.querySelector('#car-properties-container select#models');

  if (modelSelect) {
    // Listen for changes (covers live selection + session-restore dispatches)
    modelSelect.addEventListener('change', () => {
      applyInnerstep1Groups(modelSelect.value);
    });

    // Also run immediately if already populated
    if (modelSelect.value.trim() !== '') {
      applyInnerstep1Groups(modelSelect.value);
    }
  }

  // ── Fallback: read directly from sessionStorage in case select isn't populated yet ──
  // Your existing code dispatches change events during session restore, but
  // the order isn't guaranteed. This catches the case where it fires before section 6 loads.
  const stored = sessionStorage.getItem('model_filters');
  if (stored) {
    try {
      const filters = JSON.parse(stored);
      if (filters && filters.Model && filters.Model.trim() !== '') {
        // Run after a tick so the DOM groups are definitely rendered
        setTimeout(() => applyInnerstep1Groups(filters.Model), 50);
      }
    } catch(e) {}
  }

});


  
// ── 7. UPSELL "No" OPTION — exclude from summary & cart properties ──────────
document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('.product-info__buy-buttons form');
  if (!form) return;

  // ── Exclude "No" from selection_here summary span ──
  // Patch: getStepValue already skips data-upsell-no radios (done in sections 3 & 5)

  // ── Exclude from cart on submit — strip "No" properties before form posts ──
  form.addEventListener('submit', e => {
    const noInputs = form.querySelectorAll('input[data-upsell-no="true"]:checked');
    noInputs.forEach(input => {
      // Temporarily remove name so Shopify doesn't receive it
      input._savedName = input.name;
      input.removeAttribute('name');
    });

    // Restore after submit fires (so the DOM stays intact for next interaction)
    setTimeout(() => {
      noInputs.forEach(input => {
        if (input._savedName) input.setAttribute('name', input._savedName);
      });
    }, 100);
  });

  // ── Also handle Shopify Ajax cart (fetch/XHR based themes) ──
  // Intercept fetch to strip "No" upsell from FormData before it hits /cart/add
  const _origFetch = window.fetch;
  window.fetch = function(resource, options) {
    if (
      options?.body instanceof FormData &&
      typeof resource === 'string' &&
      resource.includes('/cart/add')
    ) {
      const noInputs = form.querySelectorAll('input[data-upsell-no="true"]:checked');
      noInputs.forEach(input => {
        const propKey = `properties[${input.name.replace(/^properties\[|\]$/g, '')}]`;
        options.body.delete(propKey);
      });
    }
    return _origFetch.apply(this, arguments);
  };

});



// ── 8. Edit button with upsell option  ──────────
document.addEventListener('DOMContentLoaded', function () {

  const params     = new URLSearchParams(window.location.search);
  const editKey    = params.get('edit_key');
  const upsellTrue = params.get('upsell_true') === 'true';

  if (!editKey) return;

  // Store on window so theme.js can read
  window.__editKey    = editKey;
  window.__upsellTrue = upsellTrue;

  // Flag on body for easy access anywhere
  document.body.dataset.editMode    = 'true';
  document.body.dataset.editUpsell  = upsellTrue ? 'added' : 'none';

  // Change button text to "Update"
  function setUpdateText() {
    document.querySelectorAll('button[type="submit"] span.text_value')
      .forEach(span => { span.textContent = 'Update'; });
  }
  setUpdateText(); 

});


 

// ── 9. Coverage hide options using model selection based on metaobjects window.variantHideRules ────────── 
// code in customOption.liquid
function runVariantHideRules(modelValue) {
  if (window._variantHideAppliers) {
    window._variantHideAppliers.forEach(function (fn) {
      fn(modelValue);
    });
  }
}


 

// ── 10. COVERAGE-BASED BLOCK HIDING ──────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  var cfg = window.__coverageHide;
  if (!cfg || !cfg.enabled || !cfg.triggerValue) return;

  var triggerValue = cfg.triggerValue.trim().toLowerCase();

  function normalize(str) {
    return str ? str.trim().toLowerCase() : '';
  }

  function selectFirstRadio(stepEl) {
    if (!stepEl) return;
    var firstInput = stepEl.querySelector('input[type="radio"]');
    if (!firstInput) return;
    if (!firstInput.checked) {
      firstInput.checked = true;
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      firstInput.click();
    }
  }

  function applyHide(el, alsoExclude) {
    if (!el) return;
    el.classList.add('notactive');
    if (alsoExclude) {
      el.querySelectorAll('input[name]').forEach(function (inp) {
        inp.setAttribute('data-upsell-no', 'true');
        inp.setAttribute('data-coverage-hidden', 'true');
      });
    }
    // ── KEY CHANGE: fire stepsCountChanged, NOT stepsUpdated ──
    // stepsUpdated resets the whole flow back to step 2.
    // stepsCountChanged only asks Section 1 to recalculate the count/bar.
    window.dispatchEvent(new Event('stepsCountChanged'));
  }

  function removeHide(el) {
    if (!el) return;
    el.classList.remove('notactive');
    el.querySelectorAll('input[data-coverage-hidden]').forEach(function (inp) {
      inp.removeAttribute('data-upsell-no');
      inp.removeAttribute('data-coverage-hidden');
    });
    // Same here — quiet recalculation only.
    window.dispatchEvent(new Event('stepsCountChanged'));
  }

  /*
  function applyRules(coverageValue) {
    var matched = (normalize(coverageValue) === triggerValue);

    if (cfg.hideSideBlock) {
      var sideEl = document.querySelector('.sideBlockOption');
      if (sideEl) {
        if (matched) {
          applyHide(sideEl, false);
          selectFirstRadio(sideEl);
        } else {
          removeHide(sideEl);
        }
      }
    }

    if (cfg.hideLhdRhd) {
      var lhdEl = document.querySelector('.lhdrhdblock');
      if (lhdEl) {
        if (matched) {
          applyHide(lhdEl, true);
        } else {
          removeHide(lhdEl);
        }
      }
    }
  }*/
 function applyRules(coverageValue) {
    var val = normalize(coverageValue);
    var trigger1 = triggerValue;
    var trigger2 = (cfg.triggerValue2 || '').trim().toLowerCase();

    var matched = (val === trigger1) || (trigger2 !== '' && val === trigger2);

    // Track previous state so we know if we're transitioning hide → show
    var wasMatched = applyRules._lastMatched;
    applyRules._lastMatched = matched;

    var needsFullReset = (wasMatched === true && matched === false);

    if (cfg.hideSideBlock) {
      var sideEl = document.querySelector('.sideBlockOption');
      if (sideEl) {
        if (matched) {
          applyHide(sideEl, false);
          selectFirstRadio(sideEl);
        } else {
          removeHide(sideEl);
        }
      }
    }

    if (cfg.hideLhdRhd) {
      var lhdEl = document.querySelector('.lhdrhdblock');
      if (lhdEl) {
        if (matched) {
          applyHide(lhdEl, true);
        } else {
          removeHide(lhdEl);
        }
      }
    }

    // If blocks just became visible again, reset the whole flow so
    // Section 1 re-shows them properly in sequence.
    // Skip on first run (wasMatched === undefined) to avoid resetting on page load.
    if (needsFullReset) {
      setTimeout(function () {
        if (typeof window._luxusFullReset === 'function') window._luxusFullReset();
      }, 0);
    }
  }

  var form = document.querySelector('.product-info__buy-buttons form');
  if (!form) return;

  form.addEventListener('change', function (e) {
    var input = e.target;
    if (
      input.type === 'radio' &&
      input.name &&
      input.name.indexOf('select-one') === 0
    ) {
      applyRules(input.value);
    }
  });

  var checkedCoverage = form.querySelector('input[name^="select-one"]:checked');
  if (checkedCoverage) {
    applyRules(checkedCoverage.value);
  }

});




function initLogoBlockScroll() {
  if (window.innerWidth > 768) return;

  document.querySelectorAll('.personalisation_logoBlocks').forEach(function(block) {
    const labels = block.querySelectorAll('label');
    if (labels.length <= 2) return;

    block.classList.add('logo-scroll-active');

    const wrapper = document.createElement('div');
    wrapper.className = 'logo-scroll-wrapper';
    block.parentNode.insertBefore(wrapper, block);
    wrapper.appendChild(block);

    const leftBtn = document.createElement('button');
    leftBtn.className = 'swatch-picker__arrow logo-arrow-left';
    leftBtn.setAttribute('aria-label', 'Scroll left');
    leftBtn.setAttribute('type','button');
    leftBtn.style.transform = 'translateY(-50%) scaleX(-1)';
    leftBtn.style.left = '0';
    leftBtn.style.opacity = '0';
    leftBtn.style.pointerEvents = 'none';

    const rightBtn = document.createElement('button');
    rightBtn.className = 'swatch-picker__arrow logo-arrow-right';
    rightBtn.setAttribute('aria-label', 'Scroll right');
    rightBtn.setAttribute('type','button');
    rightBtn.style.right = '0'; 
    rightBtn.style.opacity = '1';
    rightBtn.style.pointerEvents = 'auto';

    wrapper.appendChild(leftBtn);
    wrapper.appendChild(rightBtn);

    function updateArrows() {
      const maxScroll = block.scrollWidth - block.clientWidth;
      const atStart = block.scrollLeft <= 4;
      const atEnd = maxScroll <= 4 || block.scrollLeft >= maxScroll - 4;

      leftBtn.style.opacity = atStart ? '0' : '1';
      leftBtn.style.pointerEvents = atStart ? 'none' : 'auto';
      rightBtn.style.opacity = atEnd ? '0' : '1';
      rightBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
    }

    leftBtn.addEventListener('click', function() {
      block.scrollBy({ left: -(labels[0].offsetWidth + 12), behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', function() {
      block.scrollBy({ left: labels[0].offsetWidth + 12, behavior: 'smooth' });
    });

    block.addEventListener('scroll', updateArrows, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', initLogoBlockScroll);




/* ─────────────────────────────────────────────
   GLOBAL REDIRECT FUNCTION
───────────────────────────────────────────── */
function runRedirection(idVal, href) {   

  if (!href || href === '#' || href === '') return;
  var ROOT = document.querySelector(
    '.product-info__product-picker.customVariations'
  );
  var subItem = ROOT
    ? ROOT.querySelector(
        '.cv-sub-item[data-subid="' + idVal + '"]'
      )
    : null;
  if (subItem) {
    var subPicker = subItem.closest('.cv-sub-picker');
    var mainId = subPicker
      ? subPicker.getAttribute('data-parent-id')
      : null;
    var link = subItem.querySelector('a.color-swatch');
    if (link) {
      var group = link.closest(
        '.variant-picker__option-values'
      );
      if (group) {
        group
          .querySelectorAll('.color-swatch')
          .forEach(function(s) {
            s.classList.remove('is-selected');
          });
      }
      link.classList.add('is-selected');
    }
    var labelEl = subItem.querySelector('.sr-only');
    var subValEl = subPicker
      ? subPicker.querySelector('.cv-sub-selected-value')
      : null;
    if (subValEl && labelEl) {
      subValEl.textContent = labelEl.textContent;
    }
    if (subPicker) {
      var allSubs = subPicker.querySelectorAll('.cv-sub-item');
      if (allSubs.length > 1) {
        subPicker
          .querySelectorAll('.pencilArea')
          .forEach(function(p) {
            p.style.display = 'none';
          });
        var pa = subItem.querySelector('.pencilArea');
        if (pa) {
          pa.style.display = 'flex';
        }
      }
    }
    if (mainId) {
      localStorage.setItem('cvMainItem', mainId);
    }
    localStorage.setItem('cvSubItem', idVal);
    sessionStorage.setItem('cvScrollToSub', '1');
  } else {
    localStorage.setItem('cvMainItem', idVal);
    localStorage.removeItem('cvSubItem');
  }

  if (window.__ajaxReloadEnabled && window.__ajaxSectionReload) {
    window.__ajaxSectionReload.swap(href);
    return;
  }


  window.location.href = href;
}

window.initCustomVariations = function () {

  'use strict';
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return [...(ctx || document).querySelectorAll(sel)];
  }

    // ── Clear stale state if stored mainItem doesn't belong to this page's blocks ──
    var ROOT = document.querySelector('.product-info__product-picker.customVariations');
    if (ROOT) {
      var storedMainId = localStorage.getItem('cvMainItem');
      if (storedMainId) {
        var validMainItem = ROOT.querySelector('.cv-main-item[data-id="' + storedMainId + '"]');
        if (!validMainItem) {
          // The stored main item doesn't exist on this page — clear it
          localStorage.removeItem('cvMainItem');
          localStorage.removeItem('cvSubItem');
        }
      }
    }
    

  var ROOT = qs(
    '.product-info__product-picker.customVariations'
  );
  if (!ROOT) return;
  var MAIN_KEY = 'cvMainItem';
  var SUB_KEY = 'cvSubItem';
  /* ─────────────────────────────────────────────
     DYNAMIC INITIAL LIMIT
  ───────────────────────────────────────────── */
  function getInitialLimit(container, itemSelector) {
    var items = qsa(itemSelector, container);
    if (!items.length) return 4;

    items.forEach(function(item) {
      item.classList.remove('cv-see-more-hidden');
    });

    // ← ADD THIS: force the container itself into the layout
    void container.getBoundingClientRect();

    var firstTop = items[0].getBoundingClientRect().top;
    
    // If top is 0, the container is still hidden — fall back to 4
    if (firstTop === 0) return 4;          // ← ADD THIS GUARD

    var firstRowItems = items.filter(function(item) {
      return Math.abs(item.getBoundingClientRect().top - firstTop) <= 2;
    });
    return firstRowItems.length || 4;
  }
  function applySeeMoreLimit(container, itemSelector) {
    var items = qsa(itemSelector, container);
    if (!items.length) return 4;
    var limit = getInitialLimit(
      container,
      itemSelector
    );
    items.forEach(function(item, index) {
      if (index >= limit) {
        item.classList.add('cv-see-more-hidden');
      } else {
        item.classList.remove('cv-see-more-hidden');
      }
    });
    return limit;
  }
  /* ─────────────────────────────────────────────
     MAIN SEE MORE / SEE LESS
  ───────────────────────────────────────────── */
  var seeMoreBtn = qs(
    '.cv-see-more-btn',
    ROOT
  );
  var seeMoreWrap = qs(
    '.cv-see-more-wrap',
    ROOT
  );
  var mainSwatches = qs(
    '.cv-main-swatches',
    ROOT
  );
  var mainInitialLimit = 4;
  if (seeMoreBtn && mainSwatches) {
    var totalMain = qsa(
      '.cv-main-item',
      mainSwatches
    ).length;
    mainInitialLimit = applySeeMoreLimit(
      mainSwatches,
      '.cv-main-item'
    );
    if (totalMain <= mainInitialLimit) {
      if (seeMoreWrap) {
        seeMoreWrap.style.display = 'none';
      }
    } else {
      if (seeMoreWrap) {
        seeMoreWrap.style.display = 'flex';
      }
    }
    seeMoreBtn.addEventListener(
      'click',
      function(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded =
          mainSwatches.classList.toggle(
            'cv-expanded'
          );
        seeMoreBtn.classList.toggle(
          'cv-btn-expanded',
          expanded
        );
        var label = qs(
          '.cv-see-more-label',
          seeMoreBtn
        );
        if (label) {
          label.textContent =
            expanded
              ? 'See Less'
              : 'See More';
        }
      }
    );
  }
  /* ─────────────────────────────────────────────
     SUB SEE MORE / SEE LESS
  ───────────────────────────────────────────── */
  function initSubSeeMore(subPicker) {
    var subSwatches = qs('.cv-sub-swatches', subPicker);
    var subBtn      = qs('.cv-sub-see-more-btn', subPicker);
    var subBtnWrap  = qs('.cv-sub-see-more-wrap', subPicker);
    if (!subSwatches || !subBtn) return;

    // Reset expansion state
    subSwatches.classList.remove('cv-sub-expanded');
    subBtn.classList.remove('cv-sub-btn-expanded');
    var subLabel = qs('.cv-sub-see-more-label', subBtn);
    if (subLabel) { subLabel.textContent = 'See More'; }

    // Clone button first to avoid duplicate listeners
    var freshBtn = subBtn.cloneNode(true);
    subBtn.parentNode.replaceChild(freshBtn, subBtn);
    freshBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var expanded = subSwatches.classList.toggle('cv-sub-expanded');
      freshBtn.classList.toggle('cv-sub-btn-expanded', expanded);
      var lbl = qs('.cv-sub-see-more-label', freshBtn);
      if (lbl) { lbl.textContent = expanded ? 'See Less' : 'See More'; }
    });

    // Defer measurement until AFTER the sub-picker is fully painted
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        var totalSub = qsa('.cv-sub-item', subSwatches).length;
        var subInitialLimit = applySeeMoreLimit(subSwatches, '.cv-sub-item');
        if (subBtnWrap) {
          subBtnWrap.style.display = totalSub > subInitialLimit ? 'flex' : 'none';
        }
      });
    });
  }
  /* ─────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────── */
  function selectSwatch(swatchEl) {
    var group =
      swatchEl.closest(
        '.variant-picker__option-values'
      );
    if (group) {
      qsa(
        '.color-swatch',
        group
      ).forEach(function(s) {
        s.classList.remove(
          'is-selected'
        );
      });
    }
    swatchEl.classList.add(
      'is-selected'
    );
  }
  function getMainLabel(item) {
    var label =
      item.getAttribute(
        'data-label'
      );
    if (label) return label;
    var swatch =
      qs(
        'a.color-swatch, label.color-swatch',
        item
      );
    return swatch
      ? (
          swatch.getAttribute('title') ||
          swatch.getAttribute('aria-label') ||
          ''
        )
      : '';
  }
  function getSubItems(mainId) {
    var picker = qs(
      '.cv-sub-picker[data-parent-id="' +
      mainId +
      '"]',
      ROOT
    );
    return picker
      ? qsa(
          '.cv-sub-item',
          picker
        )
      : [];
  }
  function showSubPicker(mainId, defer, skipAutoClick) {
    qsa('.cv-sub-picker', ROOT).forEach(function(el) {
      el.style.display = 'none';
    });
    var target = qs('.cv-sub-picker[data-parent-id="' + mainId + '"]', ROOT);
    if (target) {
      target.style.display = '';
      if (defer) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            initSubSeeMore(target);
          });
        });
      } else {
        initSubSeeMore(target);
      }

      // ── Auto-click if only one sub-swatch — skip on page-load restore ──
      if (!skipAutoClick) {
        var subSwatches = target.querySelectorAll('a.color-swatch[href]');
        if (subSwatches.length === 1) {
          var autoHref = subSwatches[0].getAttribute('href');
          if (autoHref && window.location.pathname !== new URL(autoHref, window.location.origin).pathname) {
            subSwatches[0].click();
          }
        }
      }
    }
  }
  function scrollToSubPicker(mainId) {
    var picker = qs(
      '.cv-sub-picker[data-parent-id="' +
      mainId +
      '"]',
      ROOT
    );
    if (picker) {
      setTimeout(function() {
        picker.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 50);
    }
  }
  /* ─────────────────────────────────────────────
     MAIN ITEM CLICK
  ───────────────────────────────────────────── */
  qsa(
    '.cv-main-item',
    ROOT
  ).forEach(function(item) {
    // ── GUARD: only bind once ──
    if (item.__cvBound) return;
    item.__cvBound = true;

    item.addEventListener(
      'click',
      function(e) {
        e.preventDefault();
        e.stopPropagation();
        var mainId =
          item.getAttribute(
            'data-id'
          );
        var subItems =
          getSubItems(mainId);
        var swatch =
          qs(
            'label.color-swatch, a.color-swatch',
            item
          );
        if (swatch) {
          selectSwatch(swatch);
        }
        var mainValEl =
          qs(
            '.cv-main-selected-value',
            ROOT
          );
        if (mainValEl) {
          mainValEl.textContent =
            getMainLabel(item);
        }
        var subValEl =
          qs(
            '.cv-sub-selected-value',
            ROOT
          );
        if (subValEl) {
          subValEl.textContent = '';
        }
        if (subItems.length === 0) {
          var directHref =
            item.getAttribute(
              'data-href'
            ) || '';
          if (directHref) {
            localStorage.setItem(
              MAIN_KEY,
              mainId
            );
            localStorage.removeItem(
              SUB_KEY
            );

             // ── ADD THIS ──
            if (window.__ajaxReloadEnabled && window.__ajaxSectionReload) {
              window.__ajaxSectionReload.swap(directHref);
              return;
            }
            
            window.location.href =
              directHref;
          }
        } else {
          localStorage.setItem(
            MAIN_KEY,
            mainId
          );
          localStorage.removeItem(
            SUB_KEY
          );
          showSubPicker(
            mainId
          );
          scrollToSubPicker(
            mainId
          );
        }
      }
    );
  });
  /* ─────────────────────────────────────────────
     RESTORE STATE
  ───────────────────────────────────────────── */
  function restoreState() {
    var mainId = localStorage.getItem(MAIN_KEY);
    var subId  = localStorage.getItem(SUB_KEY);

     // ── NEW: if no selection, show the first sub-picker by default ──
    if (!mainId) {
      var firstSubPicker = qs('.cv-sub-picker', ROOT);
      if (firstSubPicker) {
        firstSubPicker.style.display = '';
        initSubSeeMore(firstSubPicker);
      }
      return;
    }
    
    if (!mainId) return;

    // ── Validate subId against current page URL ──
    if (subId) {
      var currentPath = window.location.pathname;
      var matchingSubItem = null;

      qsa('.cv-sub-item', ROOT).forEach(function(item) {
        var link = qs('a.color-swatch[href]', item);
        if (!link) return;
        try {
          var linkPath = new URL(link.getAttribute('href'), window.location.origin).pathname;
          if (linkPath === currentPath) matchingSubItem = item;
        } catch(e) {}
      });

      if (matchingSubItem) {
        // A sub-swatch on this page matches the current URL — use it
        var correctSubId = matchingSubItem.getAttribute('data-subid');
        if (correctSubId !== subId) {
          localStorage.setItem(SUB_KEY, correctSubId);
          subId = correctSubId;
        }
        // Also sync mainId to this sub-swatch's parent picker
        var correctPicker = matchingSubItem.closest('.cv-sub-picker');
        if (correctPicker) {
          var correctMainId = correctPicker.getAttribute('data-parent-id');
          if (correctMainId && correctMainId !== mainId) {
            localStorage.setItem(MAIN_KEY, correctMainId);
            mainId = correctMainId;
          }
        }
      } else {
        // No sub-swatch points to the current URL — stale, clear it
        localStorage.removeItem(SUB_KEY);
        subId = null;
      }
    }

    // ── Validate mainId exists on this page ──
    var mainItem = qs('.cv-main-item[data-id="' + mainId + '"]', ROOT);
    if (!mainItem) return;

    var mainSwatch = qs('label.color-swatch, a.color-swatch', mainItem);
    if (mainSwatch) {
      selectSwatch(mainSwatch);
    }

    // Auto-expand if restored item is beyond the dynamic initial limit
    var allMainItems = qsa('.cv-main-item', ROOT);
    var idx = allMainItems.indexOf(mainItem);
    if (idx >= mainInitialLimit && mainSwatches) {
      mainSwatches.classList.add('cv-expanded');
      if (seeMoreBtn) {
        seeMoreBtn.classList.add('cv-btn-expanded');
        var lbl = qs('.cv-see-more-label', seeMoreBtn);
        if (lbl) { lbl.textContent = 'See Less'; }
      }
    }

    var mainValEl = qs('.cv-main-selected-value', ROOT);
    if (mainValEl) {
      mainValEl.textContent = getMainLabel(mainItem);
    }

    var subItems = getSubItems(mainId);
    if (subItems.length > 0) {
      showSubPicker(mainId, true, true);

      // Scroll only after redirect
      if (sessionStorage.getItem('cvScrollToSub') === '1') {
        sessionStorage.removeItem('cvScrollToSub');
        var subPickerTarget = qs('.cv-sub-picker[data-parent-id="' + mainId + '"]', ROOT);
        if (subPickerTarget) {
          setTimeout(function() {
            subPickerTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 120);
        }
      }
    }

    if (subId) {
      var subItem = qs('.cv-sub-item[data-subid="' + subId + '"]', ROOT);
      if (subItem) {
        var subLink = qs('a.color-swatch', subItem);
        if (subLink) {
          selectSwatch(subLink);
          var spanEl = qs('.sr-only', subLink);
          var subPicker = subItem.closest('.cv-sub-picker');
          var subValEl = qs('.cv-sub-selected-value', subPicker);
          if (subValEl && spanEl) { subValEl.textContent = spanEl.textContent; }

          // Defer expand check to AFTER initSubSeeMore's rAF has run
          var subSwatches = qs('.cv-sub-swatches', subPicker);
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                var allSubItems = qsa('.cv-sub-item', subSwatches);
                var subIdx = allSubItems.indexOf(subItem);
                var subInitialLimit = getInitialLimit(subSwatches, '.cv-sub-item');
                if (subIdx >= subInitialLimit && subSwatches) {
                  subSwatches.classList.add('cv-sub-expanded');
                  var freshSubBtn = qs('.cv-sub-see-more-btn', subPicker);
                  if (freshSubBtn) {
                    freshSubBtn.classList.add('cv-sub-btn-expanded');
                    var subLbl = qs('.cv-sub-see-more-label', freshSubBtn);
                    if (subLbl) { subLbl.textContent = 'See Less'; }
                  }
                  allSubItems.forEach(function(item) {
                    item.classList.remove('cv-see-more-hidden');
                  });
                }
              });
            });
          });
        }

        // pencilArea
        var subPicker2 = subItem.closest('.cv-sub-picker');
        var allSubItems2 = subPicker2 ? qsa('.cv-sub-item', subPicker2) : [];
        if (allSubItems2.length > 1) {
          qsa('.pencilArea', subPicker2).forEach(function(p) { p.style.display = 'none'; });
          var pa = qs('.pencilArea', subItem);
          if (pa) { pa.style.display = 'flex'; }
        }
      }
    }
  }
  /* ─────────────────────────────────────────────
     INITIALIZE
  ───────────────────────────────────────────── */
  window._cvRestoreState = restoreState;

  restoreState();
  /* ─────────────────────────────────────────────
     RESIZE HANDLING
  ───────────────────────────────────────────── */
  var resizeTimer;
  window.addEventListener(
    'resize',
    function() {
      clearTimeout(
        resizeTimer
      );
      resizeTimer =
        setTimeout(function() {
          /*
           * Don't change the visible limit while
           * expanded. Recalculate when collapsed.
           */
          if (
            mainSwatches &&
            !mainSwatches.classList.contains(
              'cv-expanded'
            )
          ) {
            mainInitialLimit =
              applySeeMoreLimit(
                mainSwatches,
                '.cv-main-item'
              );
            var totalMain =
              qsa(
                '.cv-main-item',
                mainSwatches
              ).length;
            if (seeMoreWrap) {
              seeMoreWrap.style.display =
                totalMain > mainInitialLimit
                  ? 'flex'
                  : 'none';
            }
          }
          /*
           * Recalculate currently visible sub-picker.
           */
          var visibleSubPicker =
            qs(
              '.cv-sub-picker[style*="display: block"]',
              ROOT
            );
          /*
           * Shopify/browser may use display=""
           * instead of display:block, so fallback.
           */
          if (!visibleSubPicker) {
            var allSubPickers =
              qsa(
                '.cv-sub-picker',
                ROOT
              );
            visibleSubPicker =
              allSubPickers.find(function(picker) {
                return (
                  picker.offsetParent !== null
                );
              });
          }
          if (visibleSubPicker) {
            var subSwatches =
              qs(
                '.cv-sub-swatches',
                visibleSubPicker
              );
            var subBtnWrap =
              qs(
                '.cv-sub-see-more-wrap',
                visibleSubPicker
              );
            if (
              subSwatches &&
              !subSwatches.classList.contains(
                'cv-sub-expanded'
              )
            ) {
              var subLimit =
                applySeeMoreLimit(
                  subSwatches,
                  '.cv-sub-item'
                );
              var subTotal =
                qsa(
                  '.cv-sub-item',
                  subSwatches
                ).length;
              if (subBtnWrap) {
                subBtnWrap.style.display =
                  subTotal > subLimit
                    ? 'flex'
                    : 'none';
              }
            }
          }
        }, 150);
    }
  );


  document.addEventListener('click', function (e) {
    var el = e.target.closest('a.color-swatch[data-cv-id]');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    runRedirection(el.getAttribute('data-cv-id'), el.getAttribute('data-cv-href'));
  });
}

window.initCustomVariations();







// ══════════════════════════════════════════════════════════════
// AJAX SECTION RELOAD ENGINE
// (was ajax-section-reload.liquid — pure JS moved here)
// ══════════════════════════════════════════════════════════════
(function () {
  'use strict';

  // Wait until Liquid has set window.__ajaxSectionConfig
  function init() {
    var cfg = window.__ajaxSectionConfig;
    if (!cfg || !cfg.ajaxEnabled) return;

    var sectionId = cfg.sectionId;

    function getCurrentProductEl() {
      return document.querySelector(
        '#shopify-section-' + sectionId + ' .product, ' +
        '#shopify-section-' + sectionId + ' .shopify-section--main-product'
      );
    }
    function getNewProductEl(doc) {
      return doc.querySelector(
        '#shopify-section-' + sectionId + ' .product, ' +
        '#shopify-section-' + sectionId + ' .shopify-section--main-product'
      );
    }

    function fetchSection(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      u.searchParams.delete('_ab');
      u.searchParams.delete('_fd');
      u.searchParams.delete('_sc');
      return fetch(u.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }

    function getScrollOffset() {
      var a = document.querySelector('.product-info') ||
              document.querySelector('.product-gallery') ||
              getCurrentProductEl();
      return a ? (a.getBoundingClientRect().top + window.scrollY) : window.scrollY;
    }

    function rebindCarPropertiesHandlers() {
      var $ = window.jQuery || (typeof jQuery !== 'undefined' ? jQuery : null);
      if (!$) return;
      $(document).off('change.ajaxRecreate');
      window.initModelFilters();
      var model_filters = JSON.parse(sessionStorage.getItem('model_filters'));
      var yearSelect  = document.getElementById('modelyear');
      var makeSelect  = document.getElementById('make');
      var modelSelect = document.getElementById('models');
      if (!yearSelect || !makeSelect || !modelSelect) return;
      if (model_filters) { yearSelect.value = model_filters.Year; yearSelect.dispatchEvent(new Event('change')); }
      if (model_filters) { makeSelect.value = model_filters.Make; makeSelect.dispatchEvent(new Event('change')); }
      if (model_filters) { modelSelect.value = model_filters.Model; modelSelect.dispatchEvent(new Event('change')); }
    }

    function rebindUiHandlers() {
      if (typeof window._vlInjectViewLarger === 'function') {
        try { window._vlInjectViewLarger(); } catch (e) { console.error(e); }
      }
      var editBtn = document.querySelector('.editvehiclebtn');
      if (editBtn && typeof editvehicle === 'function' && !editBtn.__bound) {
        editBtn.onclick = editvehicle;
        editBtn.__bound = true;
      }
      var $ = window.jQuery || (typeof jQuery !== 'undefined' ? jQuery : null);
      if ($) {
        $('.wy-tooltip').remove();
        $('.tooltip').off('.ajaxTooltip').on('mouseenter.ajaxTooltip', function () {
          var $el = $(this), title = $el.attr('title');
          if (!title) return;
          $el.data('ToolTipText', title).removeAttr('title');
          var $tip = $('<div class="wy-tooltip wy-hide"></div>').html(title);
          $('body').append($tip);
          $el.data('tooltipTimer', setTimeout(function () { $tip.removeClass('wy-hide').fadeIn('fast'); }, 500));
        }).on('mouseleave.ajaxTooltip', function () {
          var $el = $(this);
          clearTimeout($el.data('tooltipTimer'));
          $el.attr('title', $el.data('ToolTipText'));
          $('.wy-tooltip').remove();
        }).on('mousemove.ajaxTooltip', function (e) {
          var $tip = $('.wy-tooltip');
          if (!$tip.length) return;
          var offset = 10, wW = $(window).width(), wH = $(window).height();
          var tW = $tip.width(), tH = $tip.height();
          var pLeft = (e.pageX - offset >= (wW / 4) * 3) ? e.pageX - tW - offset : e.pageX + offset;
          var pTop  = (e.pageY - offset >= (wH / 4) * 3) ? e.pageY - tH - offset : e.pageY + offset;
          $tip.css({ top: pTop, left: pLeft });
        });
      }
    }

    function reinitializeAfterSwap(container) {
      var SKIP_PATTERNS = ['customElements.define', 'customElements.get', 'window.customElements'];
      container.querySelectorAll('script').forEach(function (oldScript) {
        if (oldScript.src) return;
        var content = oldScript.textContent || '';
        for (var i = 0; i < SKIP_PATTERNS.length; i++) {
          if (content.indexOf(SKIP_PATTERNS[i]) !== -1) return;
        }
        var fresh = document.createElement('script');
        Array.from(oldScript.attributes).forEach(function (a) { fresh.setAttribute(a.name, a.value); });
        fresh.text = content;
        oldScript.parentNode.replaceChild(fresh, oldScript);
      });

      document.dispatchEvent(new CustomEvent('ajax:section:reloaded', {
        bubbles: true,
        detail: { sectionId: sectionId }
      }));

      setTimeout(function () {
        document.dispatchEvent(new Event('DOMContentLoaded'));
        window.dispatchEvent(new Event('load'));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
        document.dispatchEvent(new CustomEvent('theme:loaded'));

        if (typeof window._luxusFullReset === 'function') { try { window._luxusFullReset(); } catch (e) { console.error('[luxusFullReset]', e); } }
        if (typeof window._cvRestoreState === 'function') { try { window._cvRestoreState(); } catch (e) { console.error('[cvRestoreState]', e); } }
        if (typeof window.setTexts === 'function') { try { window.setTexts(); } catch (e) { console.error('[setTexts]', e); } }
        if (typeof window.applyCarTitleData === 'function') { try { window.applyCarTitleData(); } catch (e) { console.error('[applyCarTitleData]', e); } }

        var ms = document.querySelector('#car-properties-container select#models');
        if (ms && ms.value && typeof window.runVariantHideRules === 'function') {
          try { window.runVariantHideRules(ms.value); } catch (e) { console.error('[runVariantHideRules]', e); }
        }

        rebindUiHandlers();

        ['initStitchingSwatches', 'initNeedleSwatches', 'initLogoBlockScroll'].forEach(function (fn) {
          if (typeof window[fn] === 'function') { try { window[fn](); } catch (e) {} }
        });

        document.querySelectorAll('.cv-main-item, .cv-sub-item').forEach(function(el) {
          el.__cvBound = false;
        });
        window.initCustomVariations();

        setTimeout(function () { rebindCarPropertiesHandlers(); }, 1000);
      }, 120);
    }

    function showLoader() {
      if (document.getElementById('ajax-section-loader')) return;
      if (!document.getElementById('ajax-spinner-style')) {
        var s = document.createElement('style');
        s.id = 'ajax-spinner-style';
        s.textContent = '@keyframes ajax-spin{to{transform:rotate(360deg);}}';
        document.head.appendChild(s);
      }
      var l = document.createElement('div');
      l.id = 'ajax-section-loader';
      l.innerHTML = '<div class="ajax-spinner"></div>';
      l.style.cssText = 'position:fixed;inset:0;background:rgba(255,255,255,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);';
      l.querySelector('.ajax-spinner').style.cssText = 'width:36px;height:36px;border:3px solid #D08C3C;border-top-color:transparent;border-radius:50%;animation:ajax-spin 0.7s linear infinite;';
      document.body.appendChild(l);
    }
    function hideLoader() {
      var l = document.getElementById('ajax-section-loader');
      if (l) l.remove();
    }

    function performSwap(href) {
      if (!href || href === '#' || href === '') return false;
      var url;
      try { url = new URL(href, window.location.origin); } catch (e) { return false; }

      showLoader();
      var scrollY = window.scrollY;
      var offset  = getScrollOffset();

      fetchSection(url.toString())
        .then(function (html) {
          var trimmed = html.trim();
          if (trimmed.indexOf('<!DOCTYPE') === 0 || trimmed.indexOf('<html') === 0) {
            hideLoader();
            window.location.href = href;
            return;
          }
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var newEl = getNewProductEl(doc);
          var curEl = getCurrentProductEl();
          if (!newEl || !curEl) { hideLoader(); window.location.href = href; return; }

          curEl.style.transition = 'opacity 0.18s ease';
          curEl.style.opacity    = '0';

          setTimeout(function () {
            curEl.innerHTML    = newEl.innerHTML;
            curEl.style.opacity = '1';
            var newOff = getScrollOffset();
            window.scrollTo({ top: scrollY + (newOff - offset), behavior: 'auto' });
            try { history.pushState({}, '', url.toString()); } catch (e) {}
            hideLoader();
            reinitializeAfterSwap(curEl);
          }, 200);
        })
        .catch(function (err) {
          console.error('[AJAX Section Reload]', err);
          hideLoader();
          window.location.href = href;
        });

      return true;
    }

    window.addEventListener('popstate', function () { performSwap(window.location.href); });
    window.__ajaxSectionReload = { swap: performSwap, reinit: reinitializeAfterSwap };
  }

  // Run immediately if config already set, otherwise wait for it
  if (window.__ajaxSectionConfig) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

})();


// ══════════════════════════════════════════════════════════════
// AJAX PRODUCT VARIATIONS ENGINE
// (was ajax-product-variations.liquid — pure JS moved here)
// ══════════════════════════════════════════════════════════════
(function () {
  'use strict';

  function init() {
    var cfg = window.__ajaxProductVariationsConfig;
    if (!cfg) return;

    var sectionId = cfg.sectionId;

    function getCurrentProductEl() {
      return document.querySelector(
        '#shopify-section-' + sectionId + ' .product, ' +
        '#shopify-section-' + sectionId + ' .shopify-section--main-product'
      );
    }

    function fetchSection(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return fetch(u.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }

    function showLoader() {
      if (document.getElementById('ajax-pv-loader')) return;
      if (!document.getElementById('ajax-pv-spinner-style')) {
        var s = document.createElement('style');
        s.id = 'ajax-pv-spinner-style';
        s.textContent = '@keyframes ajax-pv-spin{to{transform:rotate(360deg);}}';
        document.head.appendChild(s);
      }
      var l = document.createElement('div');
      l.id = 'ajax-pv-loader';
      l.innerHTML = '<div class="ajax-pv-spinner"></div>';
      l.style.cssText = 'position:fixed;inset:0;background:rgba(255,255,255,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);';
      l.querySelector('.ajax-pv-spinner').style.cssText = 'width:36px;height:36px;border:3px solid #D08C3C;border-top-color:transparent;border-radius:50%;animation:ajax-pv-spin 0.7s linear infinite;';
      document.body.appendChild(l);
    }
    function hideLoader() {
      var l = document.getElementById('ajax-pv-loader');
      if (l) l.remove();
    }

    function reinitAfterSwap(container) {
      var SKIP_PATTERNS = ['customElements.define', 'customElements.get', 'window.customElements'];
      container.querySelectorAll('script').forEach(function (oldScript) {
        if (oldScript.src) return;
        var content = oldScript.textContent || '';
        for (var i = 0; i < SKIP_PATTERNS.length; i++) {
          if (content.indexOf(SKIP_PATTERNS[i]) !== -1) return;
        }
        var fresh = document.createElement('script');
        Array.from(oldScript.attributes).forEach(function (a) { fresh.setAttribute(a.name, a.value); });
        fresh.text = content;
        oldScript.parentNode.replaceChild(fresh, oldScript);
      });

      document.dispatchEvent(new CustomEvent('ajax:section:reloaded', {
        bubbles: true, detail: { sectionId: sectionId }
      }));

      setTimeout(function () {
        document.dispatchEvent(new Event('DOMContentLoaded'));
        window.dispatchEvent(new Event('load'));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
        document.dispatchEvent(new CustomEvent('theme:loaded'));

        if (typeof window.setTexts === 'function') { try { window.setTexts(); } catch(e) {} }
        if (typeof window.applyCarTitleData === 'function') { try { window.applyCarTitleData(); } catch(e) {} }
        if (typeof window._vlInjectViewLarger === 'function') { try { window._vlInjectViewLarger(); } catch(e) {} }

        var $ = window.jQuery || (typeof jQuery !== 'undefined' ? jQuery : null);
        if ($) {
          $('.wy-tooltip').remove();
          $('.tooltip').off('.pvTooltip').on('mouseenter.pvTooltip', function () {
            var $el = $(this), title = $el.attr('title');
            if (!title) return;
            $el.data('ToolTipText', title).removeAttr('title');
            var $tip = $('<div class="wy-tooltip wy-hide"></div>').html(title);
            $('body').append($tip);
            $el.data('tooltipTimer', setTimeout(function () { $tip.removeClass('wy-hide').fadeIn('fast'); }, 500));
          }).on('mouseleave.pvTooltip', function () {
            var $el = $(this);
            clearTimeout($el.data('tooltipTimer'));
            $el.attr('title', $el.data('ToolTipText'));
            $('.wy-tooltip').remove();
          }).on('mousemove.pvTooltip', function (e) {
            var $tip = $('.wy-tooltip');
            if (!$tip.length) return;
            var offset = 10, wW = $(window).width(), wH = $(window).height();
            var tW = $tip.width(), tH = $tip.height();
            var pLeft = (e.pageX - offset >= (wW / 4) * 3) ? e.pageX - tW - offset : e.pageX + offset;
            var pTop  = (e.pageY - offset >= (wH / 4) * 3) ? e.pageY - tH - offset : e.pageY + offset;
            $tip.css({ top: pTop, left: pLeft });
          });
        }

        setTimeout(function () {
          window.initModelFilters();
          var model_filters = JSON.parse(sessionStorage.getItem('model_filters'));
          var yearSelect  = document.getElementById('modelyear');
          var makeSelect  = document.getElementById('make');
          var modelSelect = document.getElementById('models');
          if (!yearSelect || !makeSelect || !modelSelect) return;
          if (model_filters) { yearSelect.value = model_filters.Year; yearSelect.dispatchEvent(new Event('change')); }
          if (model_filters) { makeSelect.value = model_filters.Make; makeSelect.dispatchEvent(new Event('change')); }
          if (model_filters) { modelSelect.value = model_filters.Model; modelSelect.dispatchEvent(new Event('change')); }
        }, 1000);
      }, 120);
    }

    function performVariationSwap(href) {
      if (!href || href === '#' || href === '') return;
      var url;
      try { url = new URL(href, window.location.origin); } catch (e) { window.location.href = href; return; }

      showLoader();
      var scrollY   = window.scrollY;
      var productEl = getCurrentProductEl();
      var offset    = productEl ? (productEl.getBoundingClientRect().top + window.scrollY) : scrollY;

      fetchSection(url.toString())
        .then(function (html) {
          var trimmed = html.trim();
          if (trimmed.indexOf('<!DOCTYPE') === 0 || trimmed.indexOf('<html') === 0) {
            hideLoader(); window.location.href = href; return;
          }
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var newEl = doc.querySelector('#shopify-section-' + sectionId + ' .product, #shopify-section-' + sectionId + ' .shopify-section--main-product');
          var curEl = getCurrentProductEl();
          if (!newEl || !curEl) { hideLoader(); window.location.href = href; return; }

          curEl.style.transition = 'opacity 0.18s ease';
          curEl.style.opacity    = '0';

          setTimeout(function () {
            curEl.innerHTML    = newEl.innerHTML;
            curEl.style.opacity = '1';
            var newOffset = curEl.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: scrollY + (newOffset - offset), behavior: 'auto' });
            try { history.pushState({}, '', url.toString()); } catch (e) {}
            hideLoader();
            reinitAfterSwap(curEl);
            var newPicker = curEl.querySelector('.defaulthere .variant-picker__option-values');
            if (newPicker) {
              newPicker.querySelectorAll('.color-swatch, .block-swatch, .media-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
              var matched = newPicker.querySelector('[href="' + url.pathname + '"], [href="' + href + '"]');
              if (matched) matched.classList.add('is-selected');
            }
          }, 200);
        })
        .catch(function (err) {
          console.error('[AJAX Product Variations]', err);
          hideLoader();
          window.location.href = href;
        });
    }

    function bindVariationSwatches() {
      document.querySelectorAll('.defaulthere .variant-picker__option-values').forEach(function (picker) {
        picker.querySelectorAll('a.color-swatch, a.block-swatch, a.media-swatch').forEach(function (link) {
          if (link.__pvBound) return;
          link.__pvBound = true;
          link.addEventListener('click', function (e) {
            var href = link.getAttribute('href');
            if (!href || href === '#') return;
            e.preventDefault();
            e.stopPropagation();
            performVariationSwap(href);
          });
        });
      });
    }

    window.addEventListener('popstate', function () { performVariationSwap(window.location.href); });
    document.addEventListener('DOMContentLoaded', bindVariationSwatches);
    document.addEventListener('ajax:section:reloaded', function () { setTimeout(bindVariationSwatches, 150); });
    window.__pvBindSwatches = bindVariationSwatches;
  }

  if (window.__ajaxProductVariationsConfig) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

})();